var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinistry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.27 65.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Minstry-04"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.2,9h-.09c-.78.63-1.78.55-2.67.82-.2.06-.37.12-.44.37.77-.08,1.47-.4,2.3-.42A11.11,11.11,0,0,0,11.36,11,3.8,3.8,0,0,1,9,12.92a12.82,12.82,0,0,0-1.19.55c-.19.08-.37.17-.33.42h0a21.15,21.15,0,0,0,2.29-1l.53-.24c-.18.54-.18,1-.79,1.31a2.58,2.58,0,0,0-1.28,1.36,1.72,1.72,0,0,1-.62.69c-.5.36-1,.73-1.52,1.07a.62.62,0,0,0-.34.59v0h0a19.62,19.62,0,0,0,1.8-1.22c.07,0,.13-.14.29-.1a5.87,5.87,0,0,0-.09,1.32.25.25,0,0,1,0,.17c-.55.6-.84,1.4-1.6,1.82A13.22,13.22,0,0,0,4.66,20.8a.44.44,0,0,0-.22.54l2.12-1.52c.17.09.1.23.1.34a3.26,3.26,0,0,0,0,1.08c.21.59-.06.9-.45,1.23a25.52,25.52,0,0,0-2.09,2.07.54.54,0,0,0-.17.65A19.67,19.67,0,0,1,6.23,23a2.65,2.65,0,0,0,.07,1.45.41.41,0,0,1-.14.4,1.94,1.94,0,0,0-.49,1.25.65.65,0,0,1-.27.49,12,12,0,0,0-1.56,2.06,1.15,1.15,0,0,0-.16.81L4.75,28A9.78,9.78,0,0,1,5.5,27c.14-.15.27-.19.37.06a2.8,2.8,0,0,0,.3.46.63.63,0,0,1,0,.76,1.83,1.83,0,0,0-.35.93,1.28,1.28,0,0,1-.26.61c-.43.61-.85,1.22-1.26,1.84-.12.17-.27.34-.08.63A12.79,12.79,0,0,1,5.8,30.14a4,4,0,0,0,.49.91.51.51,0,0,1,.06.52,3.75,3.75,0,0,1-.45,1Q5.25,33.77,4.73,35c-.12.26,0,.46.07.78a14.49,14.49,0,0,1,1.43-3,3.2,3.2,0,0,0,.91,1.45A.56.56,0,0,1,7.2,35a9,9,0,0,0-1.15,3.09v.09s-.07.45.12.49.2-.25.23-.4A8.69,8.69,0,0,1,7.17,36a2.33,2.33,0,0,0,.74,1.34c.2.18.11.39.1.6-.07,1-.44,1.85-.58,2.79a.59.59,0,0,0,.24.67,19,19,0,0,1,.49-2.24,2.42,2.42,0,0,0,1.21,1c.21.08.23.31.21.51-.07.72-.17,1.44-.22,2.16,0,.41-.23.87.3,1.22a9.2,9.2,0,0,1,.17-2.28c.37.33.88.56,1.1.89A2.17,2.17,0,0,1,11.19,44c-.07.52,0,1-.06,1.55a.31.31,0,0,0,.09.29s.1.13.18.1.08-.12.08-.19V44.3a16.77,16.77,0,0,0,1.43.94c.33.19.35.71.41,1.11s.14,1,.23,1.48c0,.17,0,.37.3.42.07-.58-.21-1.12-.15-1.76.4.25.9.34,1.17.61a2.25,2.25,0,0,1,.82,1.4,10.41,10.41,0,0,0,.18,1.35c0,.17.09.34.25.32s.11-.24.1-.36c-.06-.45-.14-.9-.22-1.34,0-.18,0-.26.2-.24a1.61,1.61,0,0,1,1.53,1.26c.18.68.35,1.35.53,2a.42.42,0,0,0,.45.48c-.17-.7-.33-1.39-.5-2.07s-.13-.52.42-.42A1.8,1.8,0,0,1,20.14,51l.4,1.54a1.33,1.33,0,0,1-1,1.34c-1.08.11-2.15.07-3.23.09a6.41,6.41,0,0,0-1.45.07c-.3.07-.54-.15-.83-.16h0a.25.25,0,0,0-.28-.19h0c-.09-.2-.22-.33-.46-.28h0c0-.22-.15-.27-.27-.38a4.36,4.36,0,0,1-.78-.64,41.54,41.54,0,0,0,5.11.25.59.59,0,0,0-.64-.32,21.92,21.92,0,0,1-5.42-.46h0a.66.66,0,0,0-.64-.55h0a1.74,1.74,0,0,0-.92-.91h0c0-.06,0-.09-.1-.09h0c0-.06,0-.09-.1-.09h0a.09.09,0,0,0-.09-.09h0A.09.09,0,0,0,9.34,50h0a.11.11,0,0,0-.1-.1h0a.11.11,0,0,0-.1-.1h0a.22.22,0,0,1,.24-.08c1.08.19,2.16.39,3.25.57.7.12,1.4.22,2.17.33a.69.69,0,0,0-.51-.38c-1.15-.18-2.3-.32-3.43-.57-.91-.2-1.94-.1-2.66-.89h0c0-.06,0-.1-.1-.09h0q0-.1-.09-.09H8c0-.1,0-.16-.1-.18h0A.68.68,0,0,0,7.46,48h0c0-.06,0-.09-.1-.1h0c.08-.12,0-.2-.05-.3h0a1.34,1.34,0,0,1,.4,0c1.35.35,2.69.72,4,1.08a1.26,1.26,0,0,0,.74.11.53.53,0,0,0-.4-.31L6.66,47h0a.35.35,0,0,0-.27-.43h0c0-.22-.07-.33-.27-.37h0a.32.32,0,0,0-.27-.37h0c0-.17,0-.26-.18-.28h0c0-.33-.31-.46-.35-.75h0a3.62,3.62,0,0,1,.47.13L9,46.25c.4.16.82.29,1.29.45a.7.7,0,0,0-.54-.51c-1.51-.59-3-1.19-4.57-1.88-.15-.06-.34-.09-.43-.24a9.94,9.94,0,0,1-1-1.77h0a16.24,16.24,0,0,1,2,.89,20.37,20.37,0,0,0,2.7,1h0c0-.34-.34-.4-.58-.5-1.15-.48-2.26-1-3.41-1.51a2.75,2.75,0,0,1-1.77-1.83c-.07-.29-.34-.52-.3-.93A23.64,23.64,0,0,0,6.5,41.57c-.17-.4-.17-.41-.45-.54a39.47,39.47,0,0,1-3.67-2c-.15-.09-.32-.16-.39-.35-.29-.83-.58-1.66-.86-2.49A.16.16,0,0,1,1.18,36c.18,0,.27.18.39.28,1.2,1,2.32,2,3.55,3h0c0-.45-.35-.65-.62-.9-1.08-1-2.17-1.88-3.27-2.81a1.49,1.49,0,0,1-.53-.91c-.1-.48-.26-1-.35-1.45a4.38,4.38,0,0,1-.13-1.44,26.06,26.06,0,0,0,3.6,4.11.67.67,0,0,0-.18-.59A35.47,35.47,0,0,1,1.28,32.6C-.17,30.47.06,31.26,0,28.85a3.37,3.37,0,0,1,.06-1,46.19,46.19,0,0,0,3,4.45,1,1,0,0,0-.2-.78C2,30.2,1.11,28.86.21,27.52A1.25,1.25,0,0,1,0,26.66c.07-.66.12-1.33.19-2,0-.16.06-.33.07-.49a1,1,0,0,1,.17-.51,57,57,0,0,0,2.35,5.51,1.39,1.39,0,0,0-.14-1C2,26.9,1.53,25.58,1,24.27A3.12,3.12,0,0,1,.63,22c.22-.63.29-1.31.58-2.05L3,24.77h.11A1.82,1.82,0,0,0,3.05,24c-.36-1-.71-2-1.06-3-.59-1.73-.59-1.74.06-3.41a17.05,17.05,0,0,1,1-2.17L3.55,21a1.26,1.26,0,0,0,.22-.92c-.07-.42-.07-.85-.11-1.27-.11-1.22-.22-2.44-.34-3.65a1,1,0,0,1,.12-.7c.42-.71.82-1.42,1.24-2.12.08-.14.13-.33.38-.4A53.81,53.81,0,0,0,5,17.33c.26-.42.27-.42.26-.69-.07-1.7.15-3.39.18-5.08a.54.54,0,0,1,.07-.35A17,17,0,0,1,7.67,8.52a2.67,2.67,0,0,1,0,.4C7.43,9.94,7.2,11,7,12a3.45,3.45,0,0,0-.12,1.28,1.31,1.31,0,0,0,.33-.75c.25-1.15.5-2.29.73-3.45A3.3,3.3,0,0,1,9.14,6.9c.13-.09.3-.18.26-.39h0c.09,0,.16,0,.17-.11h0c.43,0,.59-.51,1.07-.58-.43,1.34-.89,2.6-1.24,4a.94.94,0,0,0,.5-.63c.37-1.16.76-2.3,1.15-3.45a.83.83,0,0,1,.19-.4,13,13,0,0,1,2.23-1.43,8.22,8.22,0,0,1-.58,1.24,7.26,7.26,0,0,0-.74,1.6h0a.75.75,0,0,0,.5-.48C13,5.5,13.39,4.72,13.77,4c.07-.14.11-.3.25-.37a9.71,9.71,0,0,1,1.84-.88,1.83,1.83,0,0,1-.25.55,8.38,8.38,0,0,0-.82,1.5h0c.26,0,.37-.17.48-.36a8,8,0,0,0,.65-1.09c.41-1.07,1.36-1.25,2.38-1.57a11.26,11.26,0,0,0-.9,1.54c.63-.36,1.21-.77,1.8-1.15A13.28,13.28,0,0,1,23.06.2,14.94,14.94,0,0,1,27.23.1a2.81,2.81,0,0,1,1,.12c.27.1.62.15.66.47s-.33.38-.57.49a31.34,31.34,0,0,1-8.87,2.34c-.57.08-1.14.19-1.71.28v.14l1.71.16a4.85,4.85,0,0,1-3.59,1.14h-.5A.35.35,0,0,0,15,5.5h1.9c-.11.2-.29.24-.4.35a3.51,3.51,0,0,1-3.12,1,.52.52,0,0,0-.58.28h2a5.7,5.7,0,0,0-.52.46c-.28.33-.75.51-.85,1h0a.09.09,0,0,0-.1.08v0h0c-.13,0-.13.12-.12.22V9Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.74,13.9a.47.47,0,0,0-.33-.48l-2.47-1.14a.77.77,0,0,1-.34-.22A24,24,0,0,0,46,9.73c.82,0,1.5.32,2.22.36h.07V10c0-.21-.18-.25-.36-.28-.69-.13-1.37-.37-2.08-.44-.34,0-.41-.37-.63-.54s-.24-.32-.48-.29L44.18,8a1,1,0,0,0-.76-.75h0c.13-.32.4-.22.62-.19a8.07,8.07,0,0,0,1.39,0,.4.4,0,0,0-.37-.26,12.71,12.71,0,0,0-1.63-.08A.62.62,0,0,1,43,6.64L41.33,5.5V5.41h2a2,2,0,0,0-1.42-.24,5.09,5.09,0,0,1-3.08-1.11l1.71-.15c-.06-.16-.14-.19-.23-.2-.6-.09-1.19-.21-1.79-.28a32.43,32.43,0,0,1-7-1.66c-.59-.2-1.15-.46-1.72-.71-.18-.08-.38-.18-.39-.4s.22-.27.37-.35A2.3,2.3,0,0,1,30.87.06h3.36a4.1,4.1,0,0,1,1.51.29A22.22,22.22,0,0,1,40.37,2.9c.14.1.27.29.55.21L40,1.69h0a5.87,5.87,0,0,1,1.29.41,1.32,1.32,0,0,1,.83.72c.28.52.6,1,.9,1.52a.53.53,0,0,0,.53.33l-1.18-2a15.18,15.18,0,0,1,1.45.59,1.53,1.53,0,0,1,.83.9c.32.72.68,1.42,1,2.13a.67.67,0,0,0,.54.39c-.44-1-1-1.81-1.41-2.85a19.67,19.67,0,0,1,2,1.25.91.91,0,0,1,.4.52c.41,1.21.82,2.4,1.21,3.62.07.21.15.4.46.44-.35-1.34-.82-2.61-1.26-4a12.07,12.07,0,0,1,2.28,2A.71.71,0,0,1,50,8c.37,1.32.67,2.66.94,4,.08.43.06.92.5,1.27-.13-1-.28-1.86-.47-2.75a12.94,12.94,0,0,1-.42-2.13h0a22,22,0,0,1,2.2,2.7.74.74,0,0,1,.08.48c.09,1.67.23,3.33.18,5a.8.8,0,0,0,.27.63c0-1.83,0-3.58-.06-5.35.38.52.68,1.06,1,1.57a3.17,3.17,0,0,1,.59,2.46c-.18,1.18-.26,2.38-.35,3.57A2.31,2.31,0,0,0,54.69,21l.54-5.74a31.72,31.72,0,0,1,1.44,3.47,1.32,1.32,0,0,1,0,.92c-.49,1.37-1,2.75-1.44,4.12a1.7,1.7,0,0,0,0,1.09L57,20.09h.12c.27.89.46,1.8.64,2.71a.27.27,0,0,1-.07.21c-.68,1.75-1.32,3.52-2.11,5.22a1.39,1.39,0,0,0-.11.92c1-1.8,1.6-3.65,2.4-5.46a27.32,27.32,0,0,1,.38,3,1.09,1.09,0,0,1-.21.72c-.88,1.31-1.75,2.62-2.64,3.93a1.3,1.3,0,0,0-.25.93h0C56,31.16,56.8,30,57.56,28.81a6.08,6.08,0,0,1,.68-1V30.5A.87.87,0,0,1,58,31a24.09,24.09,0,0,1-3.25,4,.89.89,0,0,0-.33.81,32.28,32.28,0,0,0,3.57-4,12.09,12.09,0,0,1-.61,3.32c0,.09-.15.15-.23.22l-3.43,3c-.25.22-.57.42-.61.81l-.06.1h0v-.11a15.19,15.19,0,0,0,2-1.57,22.23,22.23,0,0,1,2-1.63h0a17.8,17.8,0,0,1-.9,2.76c0,.12-.16.17-.26.23a40.81,40.81,0,0,1-3.75,2,.77.77,0,0,0-.48.5v.06h.06a.67.67,0,0,0,.39-.1c.82-.41,1.66-.79,2.45-1.27a4.7,4.7,0,0,1,1.23-.66h0a12.91,12.91,0,0,1-.8,1.78.94.94,0,0,1-.5.5c-1.42.66-2.83,1.37-4.3,1.94-.22.08-.47.15-.48.51a47,47,0,0,0,4.74-2,2.08,2.08,0,0,1-.26.59c-.14.34-.47.6-.48,1h0a3.34,3.34,0,0,1-1.08.66c-1.43.6-2.85,1.18-4.3,1.73a.62.62,0,0,0-.5.51c1.64-.56,3.21-1.18,4.77-1.84.3-.13.3,0,.3.22h0c-.18,0-.23.12-.19.28h0a.72.72,0,0,0-.45.65h0c-.2,0-.31.16-.27.38h0a.27.27,0,0,0-.27.37h0c-.19,0-.31.15-.27.37h-.17L46,48.55a.56.56,0,0,0-.4.33c.16.09.3,0,.44,0l4.5-1.21c.16,0,.32-.09.46,0h0c-.25.1-.42.24-.4.53h0c-.32,0-.42.28-.57.46a2.19,2.19,0,0,1-1.37.86c-1.58.26-3.14.62-4.74.78a.69.69,0,0,0-.59.42c1.85-.23,3.65-.57,5.51-.91l-1.3,1.35c-.12.12-.28.2-.38.32a2.25,2.25,0,0,1-1.78.71c-1.27.08-2.53.22-3.8.2h-.28c-.2,0-.43,0-.42.25s.28.11.43.1l4.17-.26a.65.65,0,0,1,.31.05A13.13,13.13,0,0,1,43.89,54a.83.83,0,0,1-.44,0c-1.58,0-3.16,0-4.73-.1a1.31,1.31,0,0,1-1-1.4,17.39,17.39,0,0,0,.47-1.89.42.42,0,0,1,.22-.32.24.24,0,0,0,.18-.13c.28-.71,1-.57,1.59-.82-.19.8-.38,1.54-.55,2.28,0,.12-.17.29,0,.35s.25-.12.29-.28c.17-.67.34-1.35.53-2s.48-1.32,1.35-1.37a3,3,0,0,0,.43-.12A10.59,10.59,0,0,1,42,49.72c0,.13-.13.34.07.39s.24-.16.27-.33c0-.42.1-.84.18-1.25a2.08,2.08,0,0,1,1.19-1.65c.25-.1.49-.24.78-.39.08.61-.2,1.17-.15,1.78.32-.14.31-.42.36-.66a13.44,13.44,0,0,1,.43-2.17.3.3,0,0,1,.19-.29,4.16,4.16,0,0,0,1.34-.84c.16.57-.07,1.14.17,1.66a.36.36,0,0,0,.24-.4c0-.58,0-1.15,0-1.73,0-.4.18-.79.16-1.2a.68.68,0,0,1,.15-.15,3.24,3.24,0,0,0,1-.88,9.1,9.1,0,0,1,.15,2.27.43.43,0,0,0,.35-.5h0a11.88,11.88,0,0,0-.23-2.3c-.15-.71,0-.89.6-1.2a2,2,0,0,0,.79-.82,15.18,15.18,0,0,1,.49,2.2c.32-.11.3-.35.25-.56a12.35,12.35,0,0,0-.3-1.7c-.15-.46-.12-.93-.23-1.39a.45.45,0,0,1,.19-.47A2.2,2.2,0,0,0,51.05,36,9.92,9.92,0,0,1,52,38.8a.47.47,0,0,0,.21-.57,8.63,8.63,0,0,0-.9-2.75c-.09-.17-.18-.35-.29-.52a.53.53,0,0,1,.1-.7,2.78,2.78,0,0,0,.9-1.42,14.55,14.55,0,0,1,1.41,2.92.82.82,0,0,0,0-.83c-.37-.85-.76-1.69-1.21-2.5-.32-.58-.59-1.16,0-1.77a2.27,2.27,0,0,0,.23-.5A10.12,10.12,0,0,1,54,32.32c.12-.33.13-.34,0-.57-.35-.54-.71-1.09-1.09-1.62a2.18,2.18,0,0,1-.52-1.08,1.17,1.17,0,0,0-.28-.71.6.6,0,0,1,0-.86c.06-.09.13-.17.18-.26.25-.41.35-.42.67,0,.55.68,1,1.41,1.54,2.17a.85.85,0,0,0-.14-.84,14,14,0,0,0-1.51-2l-.06-.06c-.38-.37-.14-1-.49-1.33a1.09,1.09,0,0,1-.24-1.27,1.91,1.91,0,0,0,0-.95,20.15,20.15,0,0,1,2.32,2.39,1,1,0,0,0-.31-.88,28.2,28.2,0,0,0-2.09-2,.94.94,0,0,1-.4-1.14,2.45,2.45,0,0,0,0-1.56,20.58,20.58,0,0,1,2.25,1.57c.07-.3.08-.31-.11-.46-.59-.46-1.17-.91-1.77-1.35a7.28,7.28,0,0,1-.77-.8,3,3,0,0,1-.65-2.37l1.61,1.14c.11.08.25.29.37.13s0-.3-.18-.4L50.47,15.9a1.27,1.27,0,0,1-.42-.47,3.42,3.42,0,0,0-1.63-1.64c-.37-.18-.36-.61-.39-.95s.21-.05.3,0c.7.3,1.38.63,2.07.94.11.05.23.08.34.12Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.6,61.15c.41-.36.5,0,.64.28h0c0,.07,0,.14.1.1h0c0,.18.11.23.23.25s.1-.14.14-.23.13-.3.33-.31.13.2.2.29,0,.22.2.18h0c0,.23.16.23.29.25s.08-.15.12-.23a1.06,1.06,0,0,1,.36-.37c.86-.62,1.69,0,2.52,0a18.58,18.58,0,0,0,2.36.15c-1.46-.23-2.93-.31-4.39-.68.1-.29.32-.25.52-.23a45.38,45.38,0,0,0,8.64.25c.92-.09,1.83-.21,2.75-.32a1.46,1.46,0,0,0,.5-.06.22.22,0,0,1,.27.17.09.09,0,0,1,0,0c0,.2-.11.22-.25.24l-2.61.38a.89.89,0,0,0-.48.13,8.73,8.73,0,0,0,1.84-.14,2.2,2.2,0,0,0,.67-.12,2.16,2.16,0,0,1,1.54.14c.27.09,0,.34.12.53a.52.52,0,0,0,.51-.42c0-.24.12-.33.38-.3s.28.22.28.43a.67.67,0,0,0,0,.2.56.56,0,0,0,.45-.5c0-.14-.06-.4.17-.39s.55,0,.52.42l0,.09c.35-.18.38-.51.44-.84s0-.42.33-.52A27.5,27.5,0,0,0,48,55.59a7,7,0,0,1,.16,1.21c0,.17-.08.38.14.49v.4a.49.49,0,0,0,0,.52c.19.68-.09,1-.69,1.37a33.1,33.1,0,0,1-10.89,4.48.42.42,0,0,0-.29.19,1.23,1.23,0,0,0-.66,0,32.64,32.64,0,0,1-3.69.47c-.15,0-.3,0-.39.17-.36.12-.7-.12-1.06-.09a21.76,21.76,0,0,1-3.61,0,7.59,7.59,0,0,1-2.07-.27c.28,0,.66.16.83,0s.61-.24.94-.23c.71,0,1.42.09,2.13.08a38.56,38.56,0,0,0,8.43-.88,33.74,33.74,0,0,0,7.32-2.53c.15-.07.38-.09.36-.34,0-.7-.06-1.4-.1-2.15l-.67.56s-.19.09-.06.2c.3.26.16.62.2.93s-.26.33-.42.37-.12-.2-.18-.31,0-.11,0-.18l-.84.57c.08.09.29.12.2.29a.38.38,0,0,1-.39.19c-.28-.12,0-.45-.21-.67a2.17,2.17,0,0,1-.62.5c-.17.09-.2.14,0,.25a.18.18,0,0,1,0,.25.73.73,0,0,1-.37.14c-.12,0-.11-.11-.12-.2s0-.22,0-.37l-.73.45s-.18,0-.09.14c.36.43-.12.39-.28.44a35.18,35.18,0,0,1-13.67,1.63c-.41,0-.67-.12-.58-.61a.43.43,0,0,0,0-.16l-1,.26a.57.57,0,0,1,.19.42,1.23,1.23,0,0,1-.32,1c-.08.08-.17,0-.26,0A29.49,29.49,0,0,1,21.24,64a30.39,30.39,0,0,1-10.89-4.67.6.6,0,0,1-.29-.64c0-.29.17-.59,0-.87V57.5c.22-.33.12-.7.17-1a4.65,4.65,0,0,1,.08-.75c.08,0,.13,0,.17,0A27.44,27.44,0,0,0,18.56,60c.22.08.38.13.37.45a2.57,2.57,0,0,0,.24.86c0,.13.12.32.31.27s.08-.23.12-.35Zm2.39.64a2,2,0,0,1,.13.25c.18.72,0,.92-.73.76a33.3,33.3,0,0,1-7-2.41c-.72-.34-.71-.35-.58-1.12,0-.08.09-.26-.05-.24-.37,0-.68-.16-1-.17-.65,0-.54.58-.74.93-.06.11,0,.13.36.34a34,34,0,0,0,11.39,3.8c.85.12.85.14.85-.71s0-.79-.79-.91c-.44-.06-1.06.06-1-.7Zm23.9-3.54a1.55,1.55,0,0,1-.43,0c-.32-.08-.39,0-.36.34a8.28,8.28,0,0,0,.09,1.49c0,.13-.08.37.1.38a.53.53,0,0,0,.51-.3c.06-.11,0-.27,0-.41C45.85,59.26,45.62,58.75,45.89,58.25Zm-14.14,3.3H27.42A18.45,18.45,0,0,0,31.75,61.55Zm-18.53-3.2a.29.29,0,0,1,0-.13c0-.24-.17-.35-.41-.29a.24.24,0,0,0-.2.27.16.16,0,0,0,0,.09.26.26,0,0,0,.32.2l.11-.05c.27-.17.2.11.26.19a.33.33,0,0,0,.4.12.29.29,0,0,0,.16-.36v0a.29.29,0,0,0-.38-.15ZM43,59.88c.19,0,.31-.09.32-.26a.27.27,0,0,0-.23-.31H43c-.17,0-.3.08-.31.25a.28.28,0,0,0,.24.32Zm-2,.62a.28.28,0,0,0-.32-.25h0a.26.26,0,0,0-.26.26v0c0,.21.14.29.33.28S41,60.7,41,60.5Zm1.15-.45a.27.27,0,0,0-.24-.28h0c-.18,0-.3.06-.31.24a.27.27,0,0,0,.19.32h.1a.28.28,0,0,0,.34-.28Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.88,64.51a7.59,7.59,0,0,0,2.07.27,21.76,21.76,0,0,0,3.61,0c.36,0,.7.21,1.06.09h0A12.76,12.76,0,0,1,29,65a35.63,35.63,0,0,1-6.19-.57,30.78,30.78,0,0,1-12.58-5.05L10,59.21a.32.32,0,0,0-.44,0l0,0c-.15.21,0,.34.15.45.43.28.86.57,1.3.83a34.33,34.33,0,0,0,12.5,4.5,34.57,34.57,0,0,0,11.57,0A36.22,36.22,0,0,0,44.84,62a30,30,0,0,0,3.84-2.24c.17-.11.32-.22.18-.43s-.28-.22-.49-.07a7.44,7.44,0,0,1-.85.52,37.72,37.72,0,0,1-7.26,3.52,21.17,21.17,0,0,1-3.91,1h0a.42.42,0,0,1,.29-.19,33.1,33.1,0,0,0,10.89-4.48c.6-.35.88-.69.69-1.37a.49.49,0,0,1,.05-.52c.16.21.07.46.1.69s0,.56.42.67.35.57,0,.81a30.81,30.81,0,0,1-5.53,3,36,36,0,0,1-13.7,2.82,34.75,34.75,0,0,1-20-5.8.49.49,0,0,1-.29-.47A.4.4,0,0,1,9.6,59h0c.29,0,.28-.21.31-.4a3.33,3.33,0,0,1,.11-.83c.19.28.05.58,0,.87a.6.6,0,0,0,.29.64A30.34,30.34,0,0,0,21.24,64a30,30,0,0,0,3.39.59h.26Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.75,11c.09-.14.06-.35.26-.52.2.62.4,1.21.59,1.81a10.22,10.22,0,0,1,.34,1.07c.06.24.18.27.38.27h2.49c-.06.19-.21.23-.32.31-.61.39-1.22.78-1.84,1.16a.29.29,0,0,0-.18.37.16.16,0,0,0,0,.07c.3.77.58,1.54.9,2.4a1.07,1.07,0,0,1-.63-.57,20.36,20.36,0,0,0-1.73-2.48,4,4,0,0,0,0,1.29c-.74.44-1.38,1-2.09,1.51-.12.09-.21.22-.41.24l.23-.73c.11-.06,0,.31.22.08l1.61-2.14-.07-.08-1,.23-2.45-1.54c1-.16,1.86,0,2.77-.15H28c.08.23-.08.12-.16.12H25.72c.9.34,1.82.64,2.75.89a.34.34,0,0,0,.45-.21.29.29,0,0,0,0-.16v-2.9C28.9,11.19,28.92,11.05,28.75,11Zm.43,3.59v.08l3-.88a19.1,19.1,0,0,0-2-.07.39.39,0,0,0-.32.13c-.21.24-.45.48-.68.73Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.23,19.72c0-.18-.14-.37.08-.57a7.63,7.63,0,0,1,.5,1.46.46.46,0,0,0,.5.42h.06a4.3,4.3,0,0,1,1.24.08l-.81.52c-.62.39-.62.39-.35,1.1l.36,1-.73-.49c0-.11.33.09.16-.16s-.55-.73-.89-1.19v.8c-.54.21-.89.7-1.46.95,0-.26,0-.47.28-.57.4-.27.57-.71.9-1.08a1.3,1.3,0,0,0-.64.17,14,14,0,0,0-1.47-1,2.32,2.32,0,0,1,.91,0c.56.08.92-.08,1-.66,0,.28-.18.53-.09.82a2.26,2.26,0,0,0-1.21,0,10.86,10.86,0,0,0,1.22.4c.15,0,.18-.06.17-.19.14.06.3.19.28-.14C32.23,20.72,32.24,20.22,32.23,19.72ZM34,21.12c-.51,0-1.09-.25-1.45.44A5.28,5.28,0,0,0,34,21.12Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.35,17.44l-1.35,1a1.55,1.55,0,0,1,.26-.8V18l.9-1.2a.94.94,0,0,0-.63.17c-.21-.38-.64-.46-1-.71a2.27,2.27,0,0,1-.45-.37h1.26a.47.47,0,0,0,.51-.26v.34H34.71a11.2,11.2,0,0,0,1.27.44c.17.05.2,0,.19-.18.08,0,.19.16.2-.06s0-.51,0-.77.14-.62-.1-.89a1,1,0,0,1,.17-.59c.2.61.41,1.15.55,1.7,0,.23.14.25.32.25a8.46,8.46,0,0,1,1.42.08c-.38.24-.76.5-1.15.73a.31.31,0,0,0-.2.39.2.2,0,0,0,0,.08c.17.41.31.83.5,1.36a1.82,1.82,0,0,1-.58-.45c.07,0,.12-.06.08-.12-.29-.4-.59-.79-.9-1.21C36.4,17,36.55,17.23,36.35,17.44Zm.29-1.06L38.1,16C37.58,16,37,15.64,36.64,16.38Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.87,8.06A1.34,1.34,0,0,1,23,7.47a7.85,7.85,0,0,1,.58,1.69c.06.25.16.27.35.27h1.5a9.2,9.2,0,0,1-1.07.68c-.4.2-.46.43-.26.82A9.63,9.63,0,0,1,24.5,12a.76.76,0,0,1-.39-.22c0-.11.05-.21-.1-.24a6.65,6.65,0,0,0-.91-1.2c0,.23-.12.47.1.66h-.06c-.29-.06-.42.2-.61.32s-.59.44-.91.68c-.08-.33.23-.46.25-.69.47-.17.56-.64.88-1a.74.74,0,0,0-.61.15c-.14-.31-.47-.38-.72-.56a3.74,3.74,0,0,1-.66-.53H22c.18,0,.37,0,.38-.25.12.2.18.35-.16.33s-.62,0-.93,0a10.73,10.73,0,0,0,1.24.44c.16.06.36,0,.37-.13A4,4,0,0,0,22.87,8.06ZM23.23,10l1.47-.43C24.19,9.56,23.61,9.3,23.23,10Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.78,16.83l-1.43-.94v-.1h1.7l.11.11H20a7.8,7.8,0,0,0,1.23.43c.08,0,.21.11.24-.07s.18,0,.17-.09a7,7,0,0,0-.07-1.83c0-.14-.07-.3.15-.44.18.55.37,1.08.53,1.62a.34.34,0,0,0,.39.3H24.1c-.47.3-.84.56-1.24.78-.23.14-.28.26-.17.51s.3.8.46,1.23c-.36,0-.39-.33-.58-.47-.11-.48-.51-.76-.78-1.19-.1.3,0,.56-.15.76l-1.38,1a1,1,0,0,1,.21-.62c.49-.21.61-.7,1-1.13Zm1.08-.43,1.49-.4C22.83,15.93,22.24,15.67,21.86,16.4Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.72,5.5,29,4.79c.21.63.38,1.15.54,1.67.07.24.17.35.44.33h1.43c-.49.3-.83.56-1.21.76s-.32.32-.19.6.3.78.46,1.2A.72.72,0,0,1,30,9.07c.07-.18-.05-.18-.17-.19,0-.52-.5-.76-.78-1.12v.58m0,.05c-.41.06-.64.42-1,.61a4.46,4.46,0,0,0-.56.41c-.09-.28.22-.39.22-.62.48-.21.58-.72.94-1-.27-.1-.45.11-.66.06l-1.47-1h1.29c.15,0,.33.1.45-.09.1,0,.17.08.1.2h-1a8.65,8.65,0,0,0,1.3.44.11.11,0,0,0,.15,0,.14.14,0,0,0,0-.06c.06,0,.15,0,.15-.06V5.59c0-.18-.15,0-.22-.09ZM30.64,7c-.5,0-1.08-.31-1.42.42Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.7,23.19V23.1c-.07-.51-.51-.76-.78-1.26,0,.36-.06.59.09.8-.2-.08-.31.06-.44.16l-1.16.87a1.19,1.19,0,0,1,.17-.61c.09.14.16.08.22,0v-.12h0c.21-.12.29-.33.43-.51s.28-.23.17-.36-.31,0-.43.09,0,0-.06,0c-.17-.37-.57-.43-.85-.66a3.08,3.08,0,0,0-.48-.32h0v-.09H24a3.48,3.48,0,0,0,1.47.47c.23,0,.32-.07.31-.31V19.84s.1-.19-.08-.15a.11.11,0,0,0-.08,0l.14-.5h.11c.16.5.33,1,.48,1.51a.39.39,0,0,0,.44.35h0a4.3,4.3,0,0,1,1.29.1c-.39.24-.76.5-1.15.72a.32.32,0,0,0-.19.41l0,.06c.18.41.33.84.51,1.33a1.38,1.38,0,0,1-.52-.37C26.8,23.2,26.76,23.18,26.7,23.19Zm-.64-1.65a4.17,4.17,0,0,0,1.46-.43c-.52,0-1.13-.24-1.45.43l-.07.05h.05S26.09,21.56,26.06,21.54Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.09,11.08c-.53.25-.92.71-1.44,1-.06-.17.06-.27.09-.4s.22-.06.24-.2.17-.1.1-.22h0a1.91,1.91,0,0,0,.65-.81l.06-.06c0-.05-.08,0-.11,0a.81.81,0,0,0-.57.23c.16-.22-.07-.25-.17-.32l-1.18-.75c.19-.13.34-.07.49-.08h0a3.33,3.33,0,0,0,1.52.52V9.87h0c.07,0,.22.09.22,0a5.31,5.31,0,0,0-.13-1.73h0A1.07,1.07,0,0,1,35,7.56c.24.7.45,1.32.67,1.93a.06.06,0,0,0,0,.06c-.12.16-.34.25-.41.52a5.53,5.53,0,0,0,1.53-.52h.56a5.5,5.5,0,0,1-1.13.77c-.27.16-.34.31-.21.6s.31.8.5,1.3L36,11.71s.17-.06.1-.15c-.28-.4-.58-.78-.89-1.19C35,10.64,35.21,10.87,35.09,11.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.75,11c.17.06.15.2.15.34v2.9a.35.35,0,0,1-.31.39.3.3,0,0,1-.16,0c-.93-.25-1.85-.55-2.75-.89h2.14c.08,0,.24.11.16-.12.11-.37.21-.74.32-1.11S28.68,11.51,28.75,11Zm-.45,2.94s-.08-.09-.12,0,0,.05.06.08l.1.09a.08.08,0,0,0,.07.09h0a.08.08,0,0,0,.07.09h0s0,.09.07.06,0-.07,0-.09l-.09-.09-.09-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.4,6.51a.45.45,0,0,1-.26.39,3.34,3.34,0,0,0-1.2,2.15c-.23,1.16-.48,2.3-.73,3.45a1.31,1.31,0,0,1-.33.75A3.31,3.31,0,0,1,7,12c.2-1,.43-2,.65-3.05a2.67,2.67,0,0,0,0-.4h0c.11,0,.1-.1,0-.16l-.07-.1A13.31,13.31,0,0,1,9.4,6.51Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.11,33.69a8.89,8.89,0,0,0,2.69-5.31c.09-.42.13-.86.23-1.29a5.49,5.49,0,0,1,2.12-2.81l.05.11c-.2.2-.39.41-.61.6A4.55,4.55,0,0,0,41,28a11.15,11.15,0,0,1-1.31,4,4.54,4.54,0,0,1-1.51,1.77Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.07,16.17a4,4,0,0,1,0-1.29,20.36,20.36,0,0,1,1.73,2.48c-.33.07-.45-.24-.66-.38A12,12,0,0,1,29.07,16.17Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.6,15.28l1-.23.07.08L27,17.27c-.17.23-.11-.14-.22-.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.69,19.67c.18,0,.08.11.08.15v1.41c0,.24-.08.35-.31.31A3.58,3.58,0,0,1,24,21.07h1.05c.2,0,.23-.07.19-.24a.33.33,0,0,1,.07-.33h0A2.65,2.65,0,0,0,25.69,19.67Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.79,9.87V10a3.33,3.33,0,0,1-1.52-.52,4.18,4.18,0,0,0,1,0h.19c0,.08,0,.19.1.16s0-.22,0-.33h0V9.25c-.11-.38.3-.62.27-1l.06-.12A5.32,5.32,0,0,1,35,9.82c0,.14-.15,0-.22,0s0-.14-.08-.18h-.07a.17.17,0,0,0,.1.22Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.87,8.06A4,4,0,0,1,23,9.82c0,.15-.21.19-.37.13a10.73,10.73,0,0,1-1.24-.44h.93c.31,0,.28-.13.16-.33a2.53,2.53,0,0,1,.26-.64c.14-.06.08-.19.1-.3h0c.13,0,.08-.12.1-.19Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.44,6.89c.07-.12,0-.17-.1-.2l.38-1.19c.07,0,.21-.09.21,0V7.16a.23.23,0,0,0-.15.06h0c0-.07,0-.13-.1-.1h0c0-.09,0-.12-.1-.1h0c0-.09,0-.12-.1-.1h0c0-.08,0-.14-.1-.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.16,15.9l-.11-.11a4.33,4.33,0,0,1,.47-1.45,7,7,0,0,1,.07,1.83c0,.11-.11.06-.17.09h0c0-.09,0-.12-.1-.1h0c0-.08,0-.12-.1-.09h0c.06-.11,0-.14-.09-.19Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.23,19.72v1.49c0,.33-.14.2-.28.14h0c0-.06,0-.12-.1-.1h0c0-.09,0-.12-.1-.1h0c-.09-.29.11-.54.09-.82h0l.16,0C31.92,20.05,31.93,19.82,32.23,19.72Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.09,11.08c.12-.21-.05-.44.09-.71.31.41.61.79.89,1.19.07.09,0,.11-.1.15a1.7,1.7,0,0,1-.61-.52c0-.15-.13-.14-.24-.12Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.26,14.44c.24.27.07.59.1.89s0,.51,0,.77-.12.09-.2.06h0a.11.11,0,0,0-.1-.1h0A.09.09,0,0,0,36,16h0a.09.09,0,0,0-.08-.1h0v-.34a.45.45,0,0,1,.09-.4.6.6,0,0,0,.18-.55h0c.14,0,.09-.12.1-.19Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.35,17.44c.2-.21,0-.48.16-.78.31.42.61.81.9,1.21,0,.06,0,.1-.08.12C37,17.88,36.74,17.51,36.35,17.44Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.35,22.63v-.8c.34.46.63.82.89,1.19s-.16.05-.16.16Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.59,17.44c.19-.2.05-.46.15-.76.27.43.67.71.78,1.19-.32.15-.41-.2-.62-.3A.85.85,0,0,0,21.59,17.44Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,22.64c-.15-.21-.12-.44-.09-.8.27.5.71.75.78,1.26C26.3,23.16,26.22,22.78,26,22.64Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.78,16.83l.67-.14c-.42.43-.54.92-1,1.13A4.43,4.43,0,0,1,20.78,16.83Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.07,7.8c.21,0,.39-.16.66-.06-.36.33-.46.84-.94,1C27.71,8.41,28.13,8.17,28.07,7.8Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.43,22.1a1.3,1.3,0,0,1,.64-.17c-.33.37-.5.81-.9,1.08C31,22.64,31.38,22.41,31.43,22.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.53,16.9a.94.94,0,0,1,.63-.17l-.9,1.2v-.31Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.15,10.52a.74.74,0,0,1,.61-.15c-.32.34-.41.81-.88,1C21.82,11,22.08,10.8,22.15,10.52Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.73,10.45a1.91,1.91,0,0,1-.65.81c-.14-.18.22-.37,0-.55v-.08a.81.81,0,0,1,.57-.23Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.45,24.64a5.84,5.84,0,0,1,.93.93l-.08.09-.91-.91Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.17,23.17l.77-.86.08.07a4.51,4.51,0,0,1-.77.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.9,22.13H25c0,.29-.28.5-.17.79H24.7a.11.11,0,0,0,.06.09c.06,0-.13.17-.22,0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.35,24.08l.69-.79.07.09a3.58,3.58,0,0,1-.68.77Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.42,7.28a1,1,0,0,1,.76.75A3.38,3.38,0,0,1,43.42,7.28Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.07,10.71c.23.18-.13.37,0,.55h0c-.15,0-.09.14-.1.22a.21.21,0,0,1-.24.2Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.34,12.48c-.11.37-.21.74-.32,1.11h-.1A3.64,3.64,0,0,1,28.34,12.48Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.69,49.27c-.23-.26-.56-.49-.22-.89l.09.09c-.24.34.18.48.23.73Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.74,23.93l.66.67-.1.06a2,2,0,0,1-.64-.64Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,23.1a3.75,3.75,0,0,1,.62.7l-.08.08a2.79,2.79,0,0,1-.6-.68Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.46,48a.68.68,0,0,1,.47.56c-.13,0-.23-.22-.37-.05l-.09-.09C7.65,48.24,7.41,48.1,7.46,48Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.69,19.67c-.1.3-.21.6-.31.89h0l.3-.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.32,46a.72.72,0,0,1,.45-.65A1,1,0,0,1,52.32,46Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.24,20.85c0,.17,0,.26-.19.24h-.21A.45.45,0,0,0,25.24,20.85Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.75,9.51a.06.06,0,0,1,0-.06h1.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.65,48.13a.53.53,0,0,1,.4-.53A.88.88,0,0,1,50.65,48.13Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.22,9.45a4.18,4.18,0,0,1-1,0h1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.36,46.6a.36.36,0,0,1,.32.4v0A.59.59,0,0,1,6.36,46.6Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.5,47.06a.32.32,0,0,1,.27-.37A.39.39,0,0,1,51.5,47.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.17,14.61a.6.6,0,0,1-.18.55A.85.85,0,0,1,36.17,14.61Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.78,46.7c-.05-.22.07-.33.27-.37A.39.39,0,0,1,51.78,46.7Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.09,46.24c.2,0,.31.15.27.37A.39.39,0,0,1,6.09,46.24Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.05,46.34c0-.22.07-.33.27-.38A.41.41,0,0,1,52.05,46.34Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.82,45.87c.2.05.31.16.27.37A.39.39,0,0,1,5.82,45.87Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.85,11.55a.8.8,0,0,1-.36-.27h0A.61.61,0,0,1,23.85,11.55Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,11.53c.15,0,.13.13.1.24l-.27-.22h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.64,45.6c.17,0,.23.11.18.28A.24.24,0,0,1,5.64,45.6Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.85,8.88c.12,0,.24,0,.17.19a.29.29,0,0,1-.23-.17h.05Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.77,45.33c0-.16,0-.26.19-.28A.25.25,0,0,1,52.77,45.33Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.79,8.24c0,.11,0,.24-.1.3C22.56,8.39,22.76,8.34,22.79,8.24Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.52,8.71a.29.29,0,0,1-.2-.16h0c.1,0,.21,0,.18.19Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.33,11.16,23.14,11h.07a.12.12,0,0,1,.12.17Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.53,9.25c0,.11.09.25,0,.33s-.1-.08-.1-.16Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,33.81l.14-.12.09.08-.14.13Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.19,24.24l.16-.16.08.07-.14.14Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.89,8.09l-.06.12s0-.12.07-.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.61,23.8l.13.13-.08.09-.13-.14Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,23.29l.13-.12.08.07-.14.14Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.88,8.06c0,.07,0,.18-.1.19S22.75,8.07,22.88,8.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.26,14.43c0,.07,0,.18-.1.19S36.13,14.44,36.26,14.43Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.68,8.82c-.07,0-.13,0-.16-.11h0a.13.13,0,0,1,.18,0v0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.49,11.28a.2.2,0,0,1-.16-.12h0a.14.14,0,0,1,.18.07v0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.56,21v.09h0S23.48,21.07,23.56,21Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.22,8.93c0-.1,0-.19.12-.22C13.42,8.85,13.27,8.86,13.22,8.93Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.12,11.07c.11,0,.21,0,.24.12Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.79,22.89l.16.16-.11.06L13.71,23Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.32,8.55l-.17-.12h0c.1,0,.15,0,.18.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.57,6.4c0,.11-.08.14-.17.11S9.45,6.35,9.57,6.4Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.38,47.86c.07,0,.1,0,.1.1S7.35,48,7.38,47.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.33,8.72a.09.09,0,0,1,.08-.1h0C13.46,8.72,13.42,8.75,13.33,8.72Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,20.3l-.08.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.56,9.2v.05A0,0,0,0,0,34.56,9.2Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.4,24.6h0l-.06.11-.09-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.15,24.28h0l.1,0-.09.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.79,8.9l-.11-.08h0c.06,0,.1,0,.09.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.15,8.43h-.07m0,0c.06,0,.13,0,.09.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.7,23.19c.06,0,.1,0,.08.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,23.05v.05l-.06.1-.09-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.2,48.84a12.68,12.68,0,0,1-1.75.92A6.44,6.44,0,0,1,25.6,49c-.07,0-.12-.14-.23-.09h0c0-.16-.1-.19-.18-.26a5.24,5.24,0,0,1-1.09-1.39.73.73,0,0,1-.08-.52A9.61,9.61,0,0,0,24,43a6.37,6.37,0,0,0-1-2.69h0a1,1,0,0,1,0-1h0c.2,0,.21-.18.28-.29.45-.66.9-1.33,1.33-2a.48.48,0,0,1,.48-.26h8.14a.51.51,0,0,1,.47.25c.54.84,1.09,1.68,1.66,2.5a.61.61,0,0,1,.08.57h0c-.1,0-.09,0-.09.1h0c-.1,0-.11.09-.09.18h0a1.76,1.76,0,0,0-.46,1.09h0a7,7,0,0,0-.6,2.75,6.54,6.54,0,0,0,.12,2.16A1.61,1.61,0,0,1,34,47.82c-.13.18-.33.31-.36.55h0c-.09,0-.13,0-.09.09h0c-.1,0-.13,0-.09.09h0q-.15,0-.09.09h0c-.15-.06-.17,0-.18.15h0ZM35,39.75c-.51-.76-1-1.53-1.53-2.3a.4.4,0,0,0-.38-.17H25.45c-.14,0-.27,0-.36.13-.51.8-1.11,1.54-1.57,2.38a10.31,10.31,0,0,1,1,7,.55.55,0,0,0,0,.31,5.06,5.06,0,0,0,2.82,2.22V39.8h3.81v9c0,.41.1.45.45.28a5.38,5.38,0,0,0,2.19-1.79.86.86,0,0,0,.14-.68,10.81,10.81,0,0,1,.1-4.46A18.66,18.66,0,0,1,35,39.75Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.07,29.19a1.49,1.49,0,0,0,1.05-.57,3.69,3.69,0,0,1,0,.47c0,.23.05.38.32.39s.31.1.24.29-.2.13-.31,0a.18.18,0,0,0-.25,0c-.09.06-.06.16,0,.24s.12.33.31.36a1.42,1.42,0,0,0,.36,0c.12,0,.27,0,.26.17s-.13.15-.24.15h-.39c.19.23.41.28.55.2.4-.25.79,0,1.18,0,.07,0,.16,0,.17.1s-.06.13-.13.16-.24.1-.31.06c-.54-.29-.92.22-1.43.26,1,.14,1,1.08,1.51,1.64.1.13.18.27.31.48.15-.42.28-.77.39-1.12s.22-.3.4-.08l.16.16c.1.15.35.24.15.49s-.36.15-.53-.09a6.57,6.57,0,0,0,.12,1.4c.63-.46.63-.46.9-.14.14-.09.21-.37.42-.28a3,3,0,0,1,.7.47c.11.1,0,.26-.07.38s-.19.11-.32.06L33,34.55h0s0,.06,0,.09c.09.59.23,1.16.9,1.39.32-.7.4-.69.94-.1.17.19,0,.31,0,.43s-.09.38-.34.25-.26,0-.26.16c0,.32.32.4.49.6s.22,0,.32-.06a.16.16,0,0,1,.24.1,11.72,11.72,0,0,1,.32,1.94,4.22,4.22,0,0,1-.67-.9A8.61,8.61,0,0,1,34,37.07c-.19-.4-.67-.43-.84-.83,0-.09-.12,0-.18,0-.56.42-.56.42-1.06,0l-.22-.18c.06.73-.44.53-.81.54h-3.4a.8.8,0,0,0,.27-.83.48.48,0,0,1-.69,0,.66.66,0,0,1-.12-.17c-.13.19-.23.34-.11.52.25.41.07.5-.32.46h-.29c-.12-.13.4-.53-.22-.43-.16,0-.12-.35-.28-.48s-.19.58-.59.36a.18.18,0,0,0-.07.1c-.09.45-.52.67-.72,1,0,0-.08.56-.34.11-.05-.08-.1,0-.14.05a.41.41,0,0,0-.11.38c.06.42-.07.67-.54.67h0c0-.21.36-.45-.08-.63-.07,0,.06-.23.17-.32a9.44,9.44,0,0,1,1.38-1.07c-.17-.22-.61-.08-.59-.47s.29-.43.56-.56c-.2-.1-.44-.16-.25-.44.07-.1.09-.24.24-.24s.12.15.18.24,0,.28.17.21a2.08,2.08,0,0,0,.44-.45c.08-.09,0-.15-.1-.16s-.12-.15-.1-.25a1.42,1.42,0,0,1,.07-.22c.15-.22.05-.66.35-.67s.14.43.25.63c.12,0,.15-.07.19-.12s.23-.32.34-.49c-.13-.11-.4,0-.36-.25s0-.41.14-.5.19.19.38.21c.09-.14.2-.29.29-.45s.21-.25-.1-.35-.15-.41-.13-.64a.66.66,0,0,0-.21-.7c-.28-.21-.2-.7-.47-1-.08-.08.06-.19.18-.15s.3.09.33-.08-.24-.07-.29-.21.12-.24.29-.24H28c.11,0,.1.1.11.17-.69-.1-.77,0-.54.52C27.35,29.08,27.91,29.39,28.07,29.19Zm-1,1.45c.35.48.93.39,1.4.54a.83.83,0,0,0,.54,0,.34.34,0,0,0,.2-.33c0-.16-.14-.15-.27-.15H27.06c0-.24.19-.19.33-.19h.69c-.39-.82-1-.55-1.67-.53C26.59,30.26,26.74,30.53,27.07,30.64Zm3.21,4.6c-.09.61.38.82.77,1.09.1.07.16,0,.22,0a.84.84,0,0,0,.15-.73c-.05-.18-.14-.25-.26-.08s-.37.13-.55,0S30.43,35.24,30.28,35.24Zm1.12-.85c.07.25.15.49.24.73s.38.43.57.39.26-.38.32-.61-.1-.27-.14-.24C32,34.93,31.79,34.42,31.4,34.39ZM30,33.74a.91.91,0,0,0,.71.82h.16a1,1,0,0,0,0-1c-.1-.1-.19-.12-.23,0C30.5,34,30.25,33.85,30,33.74Zm-4,1.57c.2-.18.5-.24.5-.55s-.47-.08-.36-.46C25.78,34.62,25.89,34.94,26,35.31ZM27.43,35c.75-.37.1-.7,0-1.1C27.06,34.3,27.32,34.64,27.43,35ZM29,34.83c-.16.12-.28.26-.48.09s-.22.06-.19.17a.54.54,0,0,0,.45.44c.2,0,.26-.25.25-.45S29,34.94,29,34.83Zm-1.2-1.54c-.27.39,0,.59.19.79s.16-.09.21-.17c.31-.52-.36-.35-.45-.62Zm.93.67c-.45-.18-.22.2-.25.34s0,.37.2.32.28-.36.27-.6-.18-.09-.27,0Zm-1.6-2.79a1.52,1.52,0,0,0-.06.42c0,.15.08.42.24.38a.62.62,0,0,0,.34-.48c0-.21,0-.14-.09-.09-.33.18-.3-.18-.48-.23Zm.3,2.11c.07-.37-.26-.22-.36-.38s-.19.13-.19.22.07.4.25.42.21-.17.25-.26ZM27.87,32c-.17.31-.21.57,0,.77s.25-.08.31-.18C28.45,32.17,27.85,32.32,27.87,32Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.87,33.93c-.75-.83-1.54-1.63-2.27-2.48a14.57,14.57,0,0,1-3.37-10.86.2.2,0,0,1,.1-.21,1,1,0,0,1,.26.49,9.57,9.57,0,0,0,3.07,4.53,5.43,5.43,0,0,1,1.87,3.66A10.12,10.12,0,0,0,18.3,33.5a1.15,1.15,0,0,0,.48.52h0A6.09,6.09,0,0,0,23,36.28c.14,0,.43-.09.4.21a.44.44,0,0,1-.45.43h-.09a8.45,8.45,0,0,1-1-.21,11.35,11.35,0,0,1-4.1-2.07l-.15-.07h0a2.36,2.36,0,0,0-.73-.64Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.27,33a1.33,1.33,0,0,0-.55.55h0c-.07,0-.1,0-.1.09h0c-.07,0-.1,0-.1.09h0a4.66,4.66,0,0,0-1,.82,11.84,11.84,0,0,1-4.71,2.26c-.28.07-.37,0-.45-.28s.1-.28.26-.32c3-.62,4.64-2.65,5.62-5.37a11.09,11.09,0,0,0,.58-2.47,4.41,4.41,0,0,1,1.63-2.9,10,10,0,0,0,3.22-4.74.57.57,0,0,1,.25-.39A1.25,1.25,0,0,1,47,21a15.68,15.68,0,0,1-1,6.71,17.09,17.09,0,0,1-2.52,3.93,4.91,4.91,0,0,0-.82,1h0c-.07,0-.1,0-.1.09h0c-.07,0-.1,0-.1.09h0c-.07,0-.1,0-.1.09h0c-.06,0-.1,0-.09.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.37,48.93a6.29,6.29,0,0,0,.31,1.35c0,.19.17.13.29.09a3.76,3.76,0,0,0,.62-.27c.42-.26.63-.11.85.29a1.4,1.4,0,0,1,.21,1.43c-.14.3-.2.55-.59.22v.33c.41.69-.23,1.09-.47,1.58-.15.29-.3-.12-.53-.1a.55.55,0,0,0-.09.45,1.13,1.13,0,0,1-.47,1.06.13.13,0,0,1-.2,0h0c-.28-.29-.36,0-.34.18.08.6-.48.66-.76,1-.09.1-.16,0-.2-.08a3.45,3.45,0,0,1-.14-.34c-.08-.33-.25-.41-.59-.3-.67.21-.73.16-.73-.53,0-.42-.19-.88.24-1.23.06,0,.29-.39-.13-.4,0,0-.07,0-.09-.09A2.32,2.32,0,0,1,23,51.92c.14-.12.52-.33,0-.44a.21.21,0,0,1-.15-.26,0,0,0,0,1,0,0c.12-.47.23-.94.36-1.41a.78.78,0,0,1,.39-.43.58.58,0,0,0,.3-.56c-.67.24-.69.22-.59-.51a4.44,4.44,0,0,1,.37-1.76c.12-.19,0-.32-.25-.43s-.4-1.3-.18-1.61a.48.48,0,0,0,.06-.54c-.34.2-.37.2-.4-.2s-.23-1,.09-1.41a.27.27,0,0,0-.09-.36,1.75,1.75,0,0,1-.08-1.59c.08-.11.2,0,.27-.09h0c0,.41.27.8,0,1.22,0,.07.09.11.16.11.43,0,.4.35.39.63a4.05,4.05,0,0,1-.23,1.14c.46-.07.56.21.59.56a1.63,1.63,0,0,1,0,.54c0,.11.28.6-.25.32a.08.08,0,0,0-.08.08c0,.28-.14.59,0,.85.37.68.1,1.4.16,2.1,0,.28.3.76.49.64s.34,0,.49.11.25.35.5.35Zm.06,1.7c-.5.35-.6,0-.66-.36a.83.83,0,0,0-.1.95.15.15,0,0,0,.2.08h0C25.15,51.18,25.46,51.13,25.43,50.63Zm-1.1-1.76c-.33.34-.15.62-.06.9s.17,0,.27,0c.31-.09.39-.32.35-.67C24.58,49.38,24.39,49.29,24.33,48.87Zm-1,3.5a.72.72,0,0,0-.29.8c0,.13.09.16.22.16s.3,0,.35-.2.13-.28.05-.28c-.39,0-.29-.29-.36-.48Zm-.08-2a.77.77,0,0,0,.1.93c.21.14.46-.16.53-.52-.42.12-.41-.29-.66-.46ZM24.83,55c.21-.12.6-.1.57-.41s-.48.16-.64-.18c0,0-.14.14-.14.25A.3.3,0,0,0,24.83,55Zm-.66-3.62a.56.56,0,0,0-.05.66c.05.09,0,.28.2.24s.28-.09.28-.24.11-.32-.14-.34-.15-.26-.29-.34Zm1.94.9c-.24,0-.46.17-.63-.06-.05-.06-.12,0-.14,0a.65.65,0,0,0,.13.47c.08.14.22.07.33,0a.61.61,0,0,0,.31-.43Zm-2.92,2.8c.17-.1.42-.14.39-.39s-.42,0-.48-.3a.26.26,0,0,0-.14.3c0,.13,0,.31.23.37Zm3.14-3.59c0-.18-.1-.19-.17-.15s-.53-.27-.6.18c0,.15.08.34.18.31a.92.92,0,0,0,.59-.36Zm-.59,1.87a.5.5,0,0,1-.51-.08c-.05,0-.18.13-.14.22s0,.4.22.38a.47.47,0,0,0,.44-.48s0,0,0-.06Zm1.64-2.23a.38.38,0,0,1-.49,0c-.2.26-.11.54.16.56a.39.39,0,0,0,.38-.4.41.41,0,0,0-.05-.18Zm-.91,1.71c-.15.06-.15.18-.13.3s0,.23.18.17.27-.1.26-.26-.31,0-.31-.23Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.34,53.59c.37-.06.53-.33.34-.61,0,0-.06-.13-.16-.08-.36.19-.4-.15-.34-.3a6.72,6.72,0,0,0,.48-1.22c0-.11.14-.28.28-.26s.16.2.2.32.07.27.12.39a.33.33,0,0,1-.07.41c-.15.11-.19-.08-.28-.13s-.15-.09-.18,0c-.09.26.17.39.26.58s.18.22.32.07.26-.1.35.1a8.72,8.72,0,0,0,1.08,1.78,2.58,2.58,0,0,1,.3.8c.43,1.44.86,2.87,1.28,4.31a.6.6,0,0,1-.28.8.54.54,0,0,1-.25.06h0c-1.2.19-1.31.09-1.35-1.12,0-.21.08-.26.25-.3s.26-.06.2-.27-.12-.26-.31-.2-.28,0-.3-.21-.09-.54-.14-.81c0-.11,0-.22.09-.27a1,1,0,0,0,.26-.58c-.41.18-.53,0-.56-.38s-.23-.66.06-1c.06-.06.09-.31-.08-.35-.43-.08-.29-.42-.36-.67.19-.1.28.13.43.08.11-.26.23-.53,0-.81-.17.09-.23.37-.54.3s-.11.2-.09.31c.18,1.21.38,2.42.57,3.63l.39,2.47c0,.23,0,.33-.26.33q-.61,0-1.23.06c-.32,0-.41-.06-.41-.39V56.16c0-.33-.08-.66.24-.92.16-.13.06-.37.06-.57s-.19.14-.32,0v-.52c.28-.09.31.54.67.21s.14-.4,0-.62c-.36.37-.48.08-.6-.22ZM30.49,53c-.09.15-.32.2-.35.25-.2.32.08.45.29.37a.42.42,0,0,0,.09-.59Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.2,48.84h0c.07,0,.2,0,.18-.15h0q.12,0,.09-.09h0q.12,0,.09-.09h0q.12,0,.09-.09h0c.3,0,.3,0,.65.35.11-.44.67-.77.21-1.32a.29.29,0,0,1,.19-.39c.19,0,.13.2.15.32a7.08,7.08,0,0,1,.1,1.13c0,.51,0,.51-.51.29a.66.66,0,0,0,.25.7c.6.43.63,1.11.8,1.73,0,.09,0,.25-.16.17s-.22-.06-.25.11-.07.28.08.31c.61.16.52.66.57,1.09a5.81,5.81,0,0,1,0,.59.22.22,0,0,1-.06.19c-.35.2-.37.28-.1.54a.41.41,0,0,1,.15.4,6.36,6.36,0,0,1-.12,1c-.05.31-.15.43-.45.26s-.7-.26-.9.23c-.08.19-.24.17-.37,0s-.48-.32-.5-.67a.2.2,0,0,0-.18-.22h0a.88.88,0,0,1-.86-.9s0-.07,0-.1,0-.5-.39-.3a.18.18,0,0,1-.23-.06c-.14-.24-.39-.43-.37-.75a2.5,2.5,0,0,0,.38.15c.23.07.24-.14.26-.26s0-.39-.14-.36-.68,0-.49.48c0,0-.11,0-.11-.06,0-.73-.7-1.12-.76-1.82,0-.38.49-1.27.88-1.32s.39.18.56.33c.46.4.46.41.7-.16A11,11,0,0,0,33.2,48.84Zm.8,3.65c.12-.14.36.19.44-.11s.28-.83-.14-1.18c-.19.22-.09.74-.62.59,0,.31.25.48.33.71-.35.17-.46-.22-.72-.33-.06.53.37.69.63,1A.67.67,0,0,0,34,52.49Zm-.38-.8a1.24,1.24,0,0,0,.15-1.39c-.25.18-.06,1-.76.51,0,.42,0,.42.59.88ZM33.3,49a.85.85,0,0,0,.59,1c.09,0,.16,0,.18-.08.06-.29.22-.57,0-.92C33.84,49.41,33.59,49.07,33.3,49Zm-1.54,1.7a.75.75,0,0,0,.52.88c.11.05.18.27.33.14a.5.5,0,0,0,.18-.44c0-.13-.08-.26-.13-.39C32.24,51.34,32.09,50.76,31.76,50.7Zm.17,1.23c-.07.54.35.69.65.93s.29.07.38-.11a.66.66,0,0,0,0-.48C32.76,52.38,32.71,52.36,31.93,51.93Zm3.26,2.24c-.08.28-.25.41-.54.23-.17.47.21.59.45.79.06.06.14.08.19,0A.79.79,0,0,0,35.19,54.17Zm0-1.76c-.22.07-.07.48-.36.42s-.22.24-.18.28.39.43.58.35a.54.54,0,0,0,.17-.67.78.78,0,0,0-.2-.38Zm-2.9.66a1,1,0,0,0,.52.87c.08.05.16.15.23,0s.2-.28.16-.46a1.05,1.05,0,0,0-.09-.25c-.36.38-.52-.15-.81-.16ZM30.94,51a.57.57,0,0,0,.19.78l.09,0c.08,0,.15.1.22,0a.81.81,0,0,0,0-1C31.35,51.16,31.18,51.23,30.94,51Zm1.81,3.25c0,.55.38.65.67.84.08,0,.19.14.26,0s.22-.3.09-.5-.17-.08-.26,0-.16,0-.24,0Zm2.22-4c0,.4-.41.23-.46.44a.48.48,0,0,0,.35.55c.21.07.23-.19.29-.31a1.3,1.3,0,0,0-.15-.75Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.84,23.11l.09.09a2.79,2.79,0,0,0,.6.68l.13.14a2,2,0,0,0,.64.64l.09.09.91.91a5.84,5.84,0,0,1,1,2.91,11,11,0,0,0,2.27,5,4.93,4.93,0,0,0,3.26,1.7c.27,0,.59-.08.79.22.06.11.24.19.14.35a.4.4,0,0,1-.38.21,5,5,0,0,1-2.37-.5,8.46,8.46,0,0,1-1.75-1.28c-.13-.12-.23-.36-.49-.3h0c.1-.16-.06-.21-.12-.29a11.16,11.16,0,0,1-2.08-5.31,4.81,4.81,0,0,0-1.78-3.11,9.51,9.51,0,0,1-3.16-4.86.33.33,0,0,1,0-.24c.75.87,1.15,2,2.07,2.76Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.2,24.39l.09-.1.14-.14a3.58,3.58,0,0,0,.68-.77l.14-.14a4.51,4.51,0,0,0,.77-.86,5,5,0,0,0,1-1.49,1.91,1.91,0,0,1,.57-.69,8.11,8.11,0,0,1-1.53,3.33,20.68,20.68,0,0,1-2.2,2.29,4.41,4.41,0,0,0-1.22,2.63,11.37,11.37,0,0,1-1.46,4.31,7.46,7.46,0,0,1-3.52,3,8.92,8.92,0,0,1-1.13.29c-.42.12-.38-.25-.46-.45s.14-.29.3-.32A4.34,4.34,0,0,0,38,33.86l.14-.13A4.64,4.64,0,0,0,39.71,32,11.12,11.12,0,0,0,41,28a4.54,4.54,0,0,1,1.57-3C42.81,24.8,43,24.59,43.2,24.39Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.56,51.4c-.1-.11-.16,0-.21.05a33.62,33.62,0,0,1-4,3.13.14.14,0,0,0-.07.18H48a.25.25,0,0,1,.28.18.3.3,0,0,1-.14.34,28.63,28.63,0,0,1-8.64,4.55c-.42.14-.42.14-.73-.28A26.55,26.55,0,0,0,47,55.37c-1.37-.11-2.66.15-3.94,0h0c-.09-.48.17-.71.55-.95a27.93,27.93,0,0,0,6.69-5.76c.1-.12.19-.37.41-.17s.09.31,0,.48a24.64,24.64,0,0,1-1.93,2c-.1.1-.3.16-.23.37Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.56,48.47c.14-.17.24.07.37.05h0c-.07.12,0,.14.1.18H8a.08.08,0,0,0,.07.09h0c0,.06,0,.1.1.09h0a2.82,2.82,0,0,0,1,1h0c0,.1,0,.14.1.1h0c0,.11,0,.14.1.1h0c0,.1,0,.13.1.09h0c0,.1,0,.13.1.09h0c0,.1,0,.13.1.09h0c0,.1,0,.13.1.09h0a2.37,2.37,0,0,0,.92.91h0a1.32,1.32,0,0,0,.64.55h0a8.38,8.38,0,0,0,2,1.55h0c.11.16.22.32.46.28h0c0,.19.11.24.28.19h0a1.28,1.28,0,0,0,.68.53c.44.23.67.51.44,1H11.36a25.76,25.76,0,0,0,8.05,4.1.84.84,0,0,1-1,.19,27.3,27.3,0,0,1-7.86-4.19c-.19-.15-.61-.18-.47-.56s.47-.17.72-.18H14c.05-.1,0-.15-.08-.19A31.14,31.14,0,0,1,7.79,49.2C7.74,49,7.32,48.81,7.56,48.47Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.55,51.41A10.17,10.17,0,0,0,50,50l.37-.36c0,1,.09,2,.12,3,0,.16-.13.23-.22.32-.51.44-1,.88-1.55,1.33-.09.08-.31.09-.23.3h-3.8l1.13-.84a29.27,29.27,0,0,0,2.45-2,.72.72,0,0,0,.29-.33Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.54,54.62H10.16a.39.39,0,0,1-.21-.08A24.63,24.63,0,0,1,8,52.88a.36.36,0,0,1-.12-.28c0-.94.09-1.87.13-3A36.09,36.09,0,0,0,13.54,54.62Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.35,51.6c-.07.76-.1,1.39-.21,2,0,.24-.13.62-.59.46-.18-.06-.26.06-.21.26a1.71,1.71,0,0,1-.68,1.17h-.13c-.49-.1-.5-.09-.33.36a.26.26,0,0,1-.05.32c-.17.21-.35.42-.52.64s-.16.19-.33.09-.31.12-.43.22.06.16.12.22.11.16,0,.23c-.29.21-.31.83-.9.61-.12,0-.17.11-.23.17s.07.08.11.13.18.09.11.2a.22.22,0,0,1-.27.11c-.46-.18-.93-.36-1.38-.56-.24-.11,0-.22,0-.3L18,56.23Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.72,52.21a.76.76,0,0,1,.31.43c0,.15,0,.35-.2.27s-.21-.13-.3.05a.52.52,0,0,0,0,.56c.15.22.23-.11.47,0-.27.15-.24.59-.7.41-.12,0-.13.1-.16.17a.53.53,0,0,0,.13.44c.13.13.14.08.22,0s.2-.31.47-.34c-.16.18.28.61-.33.54-.12,0-.11.56.07.67a.53.53,0,0,1,.24.54V60.5c0,.3-.09.4-.39.38s-.9-.07-1.36-.07c-.27,0-.29-.13-.26-.34.26-1.6.51-3.2.76-4.8a4.89,4.89,0,0,1,.18-1.07c.21-.48-.19-.56-.4-.75s-.14.12-.24.15l-.09-.08.34-.63c.12,0,0,.16.1.21s0,.39.28.3a.48.48,0,0,0,.33-.49V53.2c-.71,0-.42-.39-.26-.73l.09.07c0,.34.17.44.41.14.11-.13.27-.23.26-.44Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.72,57.28c-.29-.09-.38-.44-.76-.25-.13.06-.33-.35-.49-.54s-.42-.34-.17-.64a.24.24,0,0,0,0-.3c-.11-.14-.22,0-.32,0s-.27.08-.35-.07c-.2-.36-.78-.55-.52-1.13a.18.18,0,0,0-.23-.19c-.47.17-.59-.23-.63-.48a14,14,0,0,1-.11-1.83c.64.7,1.21,1.3,1.77,1.9,1.29,1.37,2.56,2.75,3.86,4.11.22.24.18.34-.1.42l-.16.07c-1.16.5-1.15.48-2-.48C39.33,57.6,39.36,57.45,39.72,57.28Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.28,54a.71.71,0,0,0,.2.62c.22.3.16.59-.2.7s-.12.29-.05.38c.32.4.06.78,0,1.16,0,.21-.29.06-.43.11h0a.54.54,0,0,0,.19.52c.24.2.05.48,0,.72s0,.68-.5.58c-.13,0-.14.13-.16.23s0,.2.12.21c.44,0,.34.33.31.6s-.06.32-.08.49,0,.16-.09.19a3.11,3.11,0,0,1-1.71.06c-.16,0-.13-.19-.1-.3.46-1.63.87-3.28,1.4-4.89a6.31,6.31,0,0,1,1-1.46Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.77,44.07a4.1,4.1,0,0,1-1.59-.69c.57.1,1.14.21,1.72.3.28,0,.57.07.86.1a1.29,1.29,0,0,1,1.34.59,1,1,0,0,0,1,.44,6.08,6.08,0,0,1,1.7.19,1.14,1.14,0,0,1,.92.89c.09.33.45.46.75.62.08,0,.24.05.22.18s-.16.17-.28.19a1.74,1.74,0,0,1-1.14-.19.91.91,0,0,0-.72-.07.35.35,0,0,1-.43-.12c-.12-.11-.29-.23-.22-.41s.26-.06.4-.06A11.13,11.13,0,0,0,19.58,46a7.85,7.85,0,0,1-2.06-.6c-.06,0-.45-.19-.58.14h-.21a9.08,9.08,0,0,1-3.54-1.13C13.28,44.14,13.61,44.29,13.77,44.07Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.65,30.76c-.39,2.42-2.34,3.35-4.18,4.52V34c0-.15.15-.18.24-.25a17.75,17.75,0,0,0,4.86-4.72c.08-.12.17-.32.31-.28s.17.27.19.43a1.15,1.15,0,0,1-.09.63c0,.08-.1.21-.18.17-.46-.2-.34.22-.43.41a2,2,0,0,0-.1.29C47.06,31.2,47,31.2,46.65,30.76Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.53,30.83l-.26.36a1.7,1.7,0,0,1-.47-1c0-.13,0-.34-.27-.18s-.22-.05-.27-.16a.94.94,0,0,1-.11-.52c0-.2,0-.46.19-.53s.27.19.37.33a17.89,17.89,0,0,0,4.62,4.52c.16.11.4.16.43.37a5.57,5.57,0,0,1,0,1c0,.18-.2.08-.29,0-1.7-1-3.47-2-3.89-4.22C11.6,30.9,11.58,30.89,11.53,30.83Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.63,32.65c.27,0,.35-.24.49-.39A21.84,21.84,0,0,0,47.36,25a.34.34,0,0,1,.2-.38h0a9.3,9.3,0,0,0,.24,1.1c0,.17.22.48-.23.46-.17,0-.1.16-.09.25s0,.33,0,.49,0,.4-.35.27-.29,0-.25.22a3,3,0,0,1-.71,2.17A18.05,18.05,0,0,1,42.8,33.3c-.13.11-.27.29-.42.21s-.15-.32-.14-.51h0c.1,0,.13,0,.09-.1h0c.1,0,.13,0,.1-.09h0c.1,0,.13,0,.1-.09h0c.1,0,.14,0,.1-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.31,27.66c0-.27.14-.6-.38-.39-.15.06-.17-.08-.17-.19v-.6c0-.2.08-.31-.2-.24s-.16-.11-.15-.21a3.24,3.24,0,0,1,.12-.62c0-.14.07-.34.26-.33s.16.2.21.32a22.44,22.44,0,0,0,2.16,4.33,21.79,21.79,0,0,0,2.5,3.17,1.8,1.8,0,0,0,.19.2.26.26,0,0,1,0,.37l0,0c-.14.14-.25,0-.36,0a20.21,20.21,0,0,1-1.79-1.67A17.19,17.19,0,0,1,11.55,29,2.25,2.25,0,0,1,11.31,27.66Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.26,54.31c.63.79,1.19,1.47,1.75,2.16s1.22,1.51,1.84,2.25c.14.18.15.28-.1.33h0c-.43.14-.9.45-1.28.36s-.5-.67-.75-1a16.09,16.09,0,0,0-1.12-1.7C36,56,36.2,55.21,36.26,54.31Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.12,59.75a1.47,1.47,0,0,0-1,.71c-.06.1-.1.19-.24.1s-.41,0-.63,0c.17-.76,1-.62,1.4-1.08-.69.22-1.5.28-1.67,1.33-.19-.35-.34-.63-.71-.55-.06,0-.11,0-.12-.1a.28.28,0,0,1,.17-.24,3.4,3.4,0,0,1,1.07-.37,3.35,3.35,0,0,0,1.3-.48c.2-.15.4-.08.62-.07,0-.2-.37-.22-.23-.48s.24-.16.39-.13h.11v-.1c0-.13-.33-.07-.27-.29s.25-.12.38-.13c.06-.2-.29-.15-.19-.35s.24-.07.37-.07H23l-.05-.08-.27-.26c.13-.2.32,0,.46-.1v.06h0v0c0-.2-.41-.11-.29-.42s.21-.21.34-.27a.3.3,0,0,1,.4.13.26.26,0,0,1,0,.08c.07.2.3.43,0,.64-.11.08-.39.08-.06.25.07,0,0,.12-.07.18a3.44,3.44,0,0,0-.35,1.92.68.68,0,0,0,.49.49,1.44,1.44,0,0,1,.69.44,1.75,1.75,0,0,1-.72,0c-.91-.24-.92-.23-1.34.61-.14-.31-.33-.53-.69-.46h-.16s0-.14.07-.2a3.55,3.55,0,0,1,.8-.52l.09-.12C22.23,59.65,22.17,59.71,22.12,59.75Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,36.27a2.16,2.16,0,0,0,0,.36c.07.34-.1.34-.32.24a6.8,6.8,0,0,1-3.4-2.69c0-.07-.08-.19-.11-.19-.44.06-.7-.34-1.08-.42a.35.35,0,0,1-.3-.23,1.37,1.37,0,0,1-.09-.4c0-.21-.09-.52.13-.62s.36.17.52.3a31.85,31.85,0,0,0,4.15,2.86C15.85,35.69,16.09,35.91,16,36.27Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.26,36.24c-.12-.37.11-.58.47-.79a32.43,32.43,0,0,0,4.36-3c.1-.08.2-.22.35-.15s.11.24.11.37a1.24,1.24,0,0,1-.08.63c-.07.14-.27.18-.34.25-.32.31-.88.22-1.09.54a6.79,6.79,0,0,1-1.55,1.7,9.19,9.19,0,0,1-1.6.94C42.28,37,42.26,37,42.26,36.24Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.09,43.41a6.05,6.05,0,0,1-1.64.63c.2.19.46.11.68.28a7.16,7.16,0,0,1-1.88.82,8.06,8.06,0,0,1-1.55.33c-.15,0-.36.14-.46-.14a2.64,2.64,0,0,0-.62.07c-.41.12-.81.29-1.22.4a3.35,3.35,0,0,1-.63.05c-.09,0-.19,0-.23-.1a.21.21,0,0,1,.1-.23,1.55,1.55,0,0,1,1.21-.61c.52,0,1-.12,1.56-.12a1.3,1.3,0,0,0,1-.74.47.47,0,0,1,.43-.27,13.48,13.48,0,0,0,3.1-.44A.12.12,0,0,1,46.09,43.41Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.12,54.29a2.86,2.86,0,0,1-.32,2c-.59.89-1.09,1.85-1.62,2.78a.59.59,0,0,1-.78.33h0C18.29,59,18.28,59,19,58.14Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.42,59.72c.2.33.6.23.87.42.11.07.28.1.3.24s-.18.08-.26.15l-.15.11c-.26.39-.37.12-.46-.12a1.13,1.13,0,0,0-.67-.7c-.1,0-.24-.11-.3,0s.12.3.21.31a.76.76,0,0,1,.61.36c-.3.07-.61.09-.68.43a.1.1,0,0,1-.12.08h0a.3.3,0,0,1-.14-.22c-.18-.6-.47-.76-1.09-.61a2.35,2.35,0,0,1-.83.12.85.85,0,0,1,.63-.32,1.64,1.64,0,0,0,.75-.49c.16-.14-.11-.35.06-.51a.29.29,0,0,1-.08-.42.3.3,0,0,1,.08-.08v-.08a.42.42,0,0,1-.27-.54.19.19,0,0,1,0-.08c.11-.2-.35-.44.08-.55a.11.11,0,0,0-.09-.1c-.47-.27,0-.52.07-.68s.39,0,.53.11c.33.33-.13.38-.28.57.21.06.47-.13.56.17s-.21.22-.28.35v.09h.11c.15,0,.31,0,.38.15s-.16.18-.23.33c.46,0,.43.2.08.41.16.11.53-.13.41.27,0,.11-.27.12-.29.35.35-.16.59-.24.84.2.13.24.7.3,1.06.29s.42.12.64,0,.27.1.3.23-.15.11-.23.14a2.15,2.15,0,0,0-.41.51,1.61,1.61,0,0,0-1.56-1c-.07,0-.16-.11-.2,0S36.37,59.72,36.42,59.72Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.87,15a4.26,4.26,0,0,1-.13,1.28,15.86,15.86,0,0,0,.87,8.07c.14.35-.09.46-.28.67a15.1,15.1,0,0,1-1-3,20.67,20.67,0,0,1-.52-3.5,5.47,5.47,0,0,1,0-.81c0-.12,0-.31.16-.32s.07.21.24.28A7.28,7.28,0,0,1,9.87,15Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.56,24.64A9.12,9.12,0,0,1,48,23.27a16.92,16.92,0,0,0,.33-8c0-.11-.1-.22,0-.36a3.36,3.36,0,0,1,.42,1.31c.08.45.11.92.16,1.38.19,0,.11-.28.29-.24s.11.22.13.34A11.51,11.51,0,0,1,49,21.26a16.08,16.08,0,0,1-1,3.25.88.88,0,0,1-.22.4l-.34-.29Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.78,36.48c-.42.58-.42.58-.65.19a3.67,3.67,0,0,1-2.76,1.85c-.31.08-.54.1-.48-.34a1.34,1.34,0,0,0,0-.4.32.32,0,0,1,.19-.4h.05a18.53,18.53,0,0,0,4.1-2c.24-.16.34,0,.33.19a2,2,0,0,1-.22,1c-.06.11-.12.27-.27.28S46,36.54,45.78,36.48Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.12,36.76c-.24.37-.24.37-.67-.25-.2,0,0,.33-.23.31s-.25-.24-.33-.39a.64.64,0,0,1-.06-.18c-.06-.3-.27-.69,0-.89s.45.19.67.32a17.39,17.39,0,0,0,3.43,1.63c.38.14.58.31.46.72a.81.81,0,0,0,0,.31c.06.29-.07.3-.3.25A3.84,3.84,0,0,1,13.12,36.76Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.77,26.54a9.42,9.42,0,0,1-1.81-5l.49.44a10.87,10.87,0,0,1-.37-3,.38.38,0,0,1,.22.32A25.48,25.48,0,0,0,10,25.17c0,.1.1.19,0,.3A3.53,3.53,0,0,0,9.77,26.54Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.16,19a10.8,10.8,0,0,1-.36,2.89c.23,0,.26-.26.47-.26a9.29,9.29,0,0,1-1.72,4.81,1.65,1.65,0,0,1-.11-1.84,26.24,26.24,0,0,0,1.47-5.14A1.3,1.3,0,0,1,50.16,19Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.58,36.83c.32.16.51-.09.73,0-.18.69-2.37,2.11-3.66,2.37A4.16,4.16,0,0,0,45.72,38a.65.65,0,0,1,.55-.63,8.72,8.72,0,0,0,3.52-1.82c.11-.09.27-.25.39-.1s-.11.24-.2.34A12,12,0,0,1,48.58,36.83Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.94,36.86c.22-.09.4.17.68,0A9.54,9.54,0,0,1,8,35.44a.38.38,0,0,1,.51.13,8.78,8.78,0,0,0,3.4,1.76.73.73,0,0,1,.62.81v0a2.91,2.91,0,0,0,0,.59c.06.49.06.49-.41.3a9.39,9.39,0,0,1-2.9-1.77A.64.64,0,0,1,8.94,36.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.46,25.09c.31-.17.33,0,.25.23a8.13,8.13,0,0,1-1.08,2.19l-.85,1.23c-.13.18-.24.25-.4,0a1,1,0,0,1-.13-.95,5.35,5.35,0,0,1,.8-1.44A12,12,0,0,0,50.83,23c0-.09.07-.18.11-.27a2.33,2.33,0,0,1-.25,1.71c-.09.21-.3.39-.22.66h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.8,25.05a10.25,10.25,0,0,1-.56-1.52,1.37,1.37,0,0,1,0-.75c.29.67.55,1.34.89,2A11.91,11.91,0,0,0,9.59,26.9a4,4,0,0,1,.51,1.34c.09.23-.25.48-.4.79A14.44,14.44,0,0,1,8,26.56a6.07,6.07,0,0,1-.54-1.29c-.09-.32.1-.22.25-.17l.06.06C7.86,25.12,7.84,25.09,7.8,25.05Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.34,55.47c.66.53,1.25,1.1,1.91,1.6a.49.49,0,0,1,.16.32c.12.52.23,1,.34,1.55a.92.92,0,0,1-.83,1,.49.49,0,0,1-.17,0c-.09,0-.1-.09-.12-.16C33.19,58.33,32.77,56.9,32.34,55.47Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.59,56a1.94,1.94,0,0,1-.16.86c-.29,1-.61,2.1-.89,3.15-.07.25-.14.3-.35.12A.5.5,0,0,0,24,60c-.86-.2-.76-.67-.58-1.35a2.81,2.81,0,0,1,1.3-1.91A6.81,6.81,0,0,0,25.59,56Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.51,30.72l.52.11h.05v0c-.26-.33-.52-.66-.76-1a2,2,0,0,1-.38-.9A22.64,22.64,0,0,0,8.47,30.6a14.21,14.21,0,0,0,1.7,1.4c.15.1.27.18.24.39A2.9,2.9,0,0,0,10.55,34a10.7,10.7,0,0,1-3.1-3.15Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.71,33.81a2.83,2.83,0,0,0,.13-1.47A.29.29,0,0,1,48,32a14.43,14.43,0,0,0,3.19-2.9.29.29,0,0,0,.17-.09,5.26,5.26,0,0,1-1.2,1.81,5,5,0,0,0,.64-.15,9.08,9.08,0,0,1-3,3.19Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.42,40.48A4,4,0,0,1,14,39.32c-.21-.2-.6-.16-.66-.53h-.08c-.12.06-.24.24-.36,0a1.13,1.13,0,0,1-.12-.7c0-.2.15-.14.27-.09a12.15,12.15,0,0,0,3.11,1,1.26,1.26,0,0,1,.62,1.45C16.69,40.55,16.55,40.46,16.42,40.48Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.46,38.32c-.14.1.14.7-.45.41-.09,0-.1,0-.14.07a8.93,8.93,0,0,1-1.78,1.28,3.54,3.54,0,0,1-1.35.38c-.2,0-.28,0-.3-.26a1.12,1.12,0,0,1,.84-1.33l.16,0A10.85,10.85,0,0,0,45.06,38C45.35,37.88,45.53,37.86,45.46,38.32Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.58,27.74c0-.3-.24-.47-.36-.71a4.43,4.43,0,0,1-.45-1.23c.13,0,.14.09.17.15a12.12,12.12,0,0,0,2.38,3.13,1.26,1.26,0,0,1,.43.87,5.23,5.23,0,0,0,.49,1.68c-.26,0-.34-.21-.45-.32A12,12,0,0,1,7.31,28c0-.12-.19-.26-.06-.37s.22,0,.33.06h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.64,27.64c.14.1.25-.08.45,0a11.68,11.68,0,0,1-3,4c-.16-.14,0-.22,0-.3a4.11,4.11,0,0,0,.29-.9,2.59,2.59,0,0,1,1-1.81,12,12,0,0,0,2-2.82,4.83,4.83,0,0,1-.77,1.88v.06h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,32.84c-.14.48-.62.58-.94.86-.09.08-.26.09-.24.24s.23,0,.31.16a7,7,0,0,1-3.13,2.54,3.35,3.35,0,0,0,0-1.41c0-.13,0-.19.15-.24a26.51,26.51,0,0,0,3.79-2.2A.1.1,0,0,0,50.66,32.84Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.58,32.86c.13-.06.19,0,.26.08a21.8,21.8,0,0,0,3.48,2c.13.07.3.1.24.32a2.29,2.29,0,0,0,0,1.27c-.12.11-.2,0-.27,0a7.22,7.22,0,0,1-2.7-2.17c-.09-.11-.33-.27,0-.37.17-.05.05-.15,0-.21l-.78-.56A.4.4,0,0,1,7.58,32.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.54,38c-.49.81-1.35.93-2,1.38.13.13.35,0,.45.24a9.43,9.43,0,0,1-3.6,1.85A2.57,2.57,0,0,0,45,40a.24.24,0,0,1,.22-.24A14.67,14.67,0,0,0,49.33,38Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.86,41.48a.66.66,0,0,1-.56-.09,9.94,9.94,0,0,1-3-1.71c.1-.2.32-.11.43-.24C10.08,39,9.17,38.89,8.81,38c.43.23.85.48,1.29.7a12.94,12.94,0,0,0,2.75,1,.45.45,0,0,1,.43.47,2.24,2.24,0,0,0,.58,1.24Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.87,36c.26.47-.16.77-.34,1a4.29,4.29,0,0,1-2.11,1.38,1.34,1.34,0,0,1-.27.07c-.19,0-.48.13-.55,0a1,1,0,0,1-.1-.81.86.86,0,0,1,.76-.59A6.48,6.48,0,0,0,41.87,36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.33,36a7.47,7.47,0,0,0,3,1.08c.33.05.36.39.46.62a.82.82,0,0,1-.14.73c-.14.23-.19,0-.29,0a3.4,3.4,0,0,1-2.16-1c-.28-.28-.55-.56-.8-.86C16.26,36.48,16.32,36.3,16.33,36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.9,54.25h4.28v.1c-.77.38-1.54.73-2.29,1.14a.79.79,0,0,1-1.1-.11l-.09-.14a5.89,5.89,0,0,0-.94-.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,55.51c-.13-.29-.44-.3-.66-.42A10.9,10.9,0,0,1,15,54.31h4.29a12,12,0,0,1-1.22,1.35c-.13.14-.26.11-.41,0a.85.85,0,0,0-.68-.19Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.45,38.34a3,3,0,0,1-2-1.11c-.15-.21-.42-.26-.6-.45s-.28-.39-.18-.58.31,0,.46,0a11,11,0,0,0,2.63.81h.17c.17.41-.18.73-.21,1.11S22.58,38.39,22.45,38.34Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.35,43.41a8.92,8.92,0,0,1-3.78-1.26c.28-.21.59,0,.9-.22a8,8,0,0,1-1.73-1,.9.9,0,0,1,.66.14A14.34,14.34,0,0,0,14,41.9a.3.3,0,0,1,.31.22A2.49,2.49,0,0,0,15.35,43.41Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.72,33.56c.23,0,.42,0,.44.31s.14.45-.23.44c-.15,0-.08.14-.11.21s-.08.19-.1.18c-.49-.12-.37.34-.48.54a3.29,3.29,0,0,1-2.14,1.49.19.19,0,0,1-.28-.18c0-.4-.06-.72.44-.94A8,8,0,0,0,41.43,34c.06-.06.21-.1.11-.24h0c.1,0,.13,0,.1-.09h0c.1,0,.14,0,.1-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.6,34.56c-.09.18.1.22.18.29a6.82,6.82,0,0,0,1.4.93c.14.08.27.13.26.36,0,.69-.1.76-.75.49a2.66,2.66,0,0,1-1.83-1.81c0-.08,0-.17-.13-.12-.29.16-.31,0-.32-.23s0-.14-.13-.11-.21-.16-.22-.3a.43.43,0,0,1,.19-.43c.13-.08.2.08.3.15s.15.23.32.15h0a.89.89,0,0,0,.73.64Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.48,41a6.47,6.47,0,0,1-1.72.92c.12.15.27.13.41.16s.3,0,.5.07A8.22,8.22,0,0,1,43,43.32a2.76,2.76,0,0,0,.88-1.27c0-.11.13-.11.22-.13a16.4,16.4,0,0,0,3.14-1C47.35,40.86,47.4,40.86,47.48,41Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.06,28.19a.8.8,0,0,1,.93,0c.26.18.42.12.45-.22s-.09-.56.36-.4h.06c.23-.63.77-.42,1.21-.44a6,6,0,0,1,2.11.19c.33.11.7.19.82.62a4.17,4.17,0,0,0-1.5-.43,2.65,2.65,0,0,0-2.46.18c-.13.11-.39,0-.36.33s-.06.34.3.28a.78.78,0,0,1,.86.32c.06.13.22.05.33.06a7.42,7.42,0,0,1,1.49.1h-2.3c-.16,0-.22-.09-.36.12a.62.62,0,0,1-.77,0,.41.41,0,0,0-.41-.12c-.65.17-.75.09-.75-.56Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.51,40.08a3.18,3.18,0,0,1,.13,1.59c0,.08,0,.13-.13.14-.3,0-.36.25-.15.51s.28.19.24.4c-.06.4-.11.81-.17,1.21a.11.11,0,0,1-.1.06c-.36.08-.47.29-.28.62.29.49,0,.93-.07,1.39,0,.14-.14.13-.19,0s-.38-.08-.27-.38a1.54,1.54,0,0,0-.05-1.4c-.1-.17,0-.38,0-.58s.14-.32.38-.29.12-.09.11-.19a9.22,9.22,0,0,1-.08-1.74h0c.16,0,.47.14.43-.17a7.06,7.06,0,0,1,0-.92h0c.14,0,.18-.06.09-.18h0c.13,0,.1,0,.09-.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.94,39.69c0,.35-.15.47-.54.39a2.6,2.6,0,0,1-1.73-1c-.07-.1-.13-.23-.25,0H17.3c0-.38-.51,0-.57-.37a2,2,0,0,1-.09-.49c0-.21.14-.15.25-.09a6.36,6.36,0,0,0,2.56.67C19.67,38.81,20,39.3,19.94,39.69Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.84,41.73a1.06,1.06,0,0,1,.95-1,13.05,13.05,0,0,0,2.31-.43c.13,0,.3-.17.41,0s0,.29-.07.42-.19.35-.36.25-.26,0-.37.1-.2.3-.38.06-.18,0-.25.09a4.79,4.79,0,0,1-1.87.87C41,42.07,40.76,42.06,40.84,41.73Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.61,36.46A.77.77,0,0,1,38,37c-.06,0-.1.09-.14.15a2.81,2.81,0,0,1-1.76,1.1c-.21.06-.26,0-.29-.21a7,7,0,0,0-.19-.79c-.07-.19,0-.24.17-.27a12.55,12.55,0,0,0,2.53-.85C38.56,36,38.65,36.1,38.61,36.46Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.63,38.26A.68.68,0,0,1,41,39a.75.75,0,0,1-.21,0c-.2,0-.2.09-.26.16a2.55,2.55,0,0,1-1.85.91c-.27,0-.34-.08-.37-.32a.76.76,0,0,1,.5-1,.73.73,0,0,1,.25,0,6.11,6.11,0,0,0,2.25-.63C41.5,38,41.66,37.94,41.63,38.26Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.4,41.76c.06.3-.08.35-.39.28a4.67,4.67,0,0,1-1.87-.88c-.12-.1-.19-.21-.29,0h-.08a4.4,4.4,0,0,1-1-.65c0-.1-.09-.21,0-.3s.17,0,.25,0a13.58,13.58,0,0,0,2.76.52A1.5,1.5,0,0,1,17.4,41.76Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.59,41.56c-.59,0-.69-.11-.6-.56a.81.81,0,0,1,.81-.67,6.78,6.78,0,0,0,2-.3c.09,0,.21-.16.29,0a.5.5,0,0,1-.08.47.21.21,0,0,1-.22.14.9.9,0,0,0-.65.2A2.18,2.18,0,0,1,38.59,41.56Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.87,55.79V56c-.21.42,0,.9-.22,1.37a22.05,22.05,0,0,1-2.81-1.76h2.79C14.79,55.57,14.75,55.76,14.87,55.79Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.49,55.55a20.11,20.11,0,0,1-2.85,1.8c0-.55-.06-1.05-.1-1.54,0-.2.07-.26.25-.26Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.74,41.58a2,2,0,0,1-1.64-.74.66.66,0,0,0-.66-.22c-.16.05-.19-.06-.23-.14a.44.44,0,0,1-.05-.43c.05-.1.16,0,.24,0a7.1,7.1,0,0,0,2.19.34.86.86,0,0,1,.65,1v0C20.12,41.67,19.9,41.53,19.74,41.58Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.85,43.36a3.31,3.31,0,0,1-1.44-.4A3.66,3.66,0,0,0,15,42.5a.67.67,0,0,1-.52-.57c-.07-.27.15-.18.28-.14a9.86,9.86,0,0,0,2,.47,2.09,2.09,0,0,1,1.3.53.34.34,0,0,1,.13.39C18.11,43.35,18,43.35,17.85,43.36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.51,43.31c-.17,0-.36.07-.43-.17s.05-.32.21-.45a1.87,1.87,0,0,1,1-.45,9.71,9.71,0,0,0,2.12-.48c.1,0,.24-.11.32,0a.25.25,0,0,1-.08.29c-.17.18-.28.37-.63.39a2.07,2.07,0,0,0-1,.29A3.45,3.45,0,0,1,40.51,43.31Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.08,40a2.13,2.13,0,0,1-1.24-.68c-.26-.29-.43-.65-.79-.84A.33.33,0,0,1,20,38l0,0c.1-.13.21,0,.3.09a3.45,3.45,0,0,0,1.71.54c.42,0,.6.14.45.58a3.7,3.7,0,0,0-.1.58C22.34,40,22.27,40.05,22.08,40Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.28,46.56c.16-.21.38-.15.5-.35a8,8,0,0,1-1.52-.42,5.66,5.66,0,0,1,1.23.08H17a1.07,1.07,0,0,1,.92.94c0,.1-.07.12-.15.12A7,7,0,0,1,15.28,46.56Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,59.39c-1.15,0-1.45-.23-1.76-1.25a2.12,2.12,0,0,1-.11-1.76c.33.52.64,1,.94,1.5Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.32,59.33,22.17,56c.49,1-.1,1.87-.5,2.68C21.44,59.13,20.87,59.22,20.32,59.33Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.45,46.31c.12-.4.39-.49.79-.47a13.07,13.07,0,0,0,2.65-.11,4.3,4.3,0,0,1-1.44.44c.11.2.35.14.49.33a6.2,6.2,0,0,1-2.63.36c-.06-.23.21-.35.15-.56Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.93,38.85c0-.15,0-.24.17-.24A3.57,3.57,0,0,0,38.05,38c.07,0,.15-.08.19,0s.08.33,0,.39c-.66.43-.94,1.29-1.79,1.5-.34.09-.44,0-.45-.3A2.82,2.82,0,0,0,35.93,38.85Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.16,55.73a20,20,0,0,1-2.87-2.4c-.15-.15-.2-.32,0-.48a.31.31,0,0,1,.44,0s0,0,0,0c.66.61,1.33,1.19,2,1.74h0A2.77,2.77,0,0,0,10.16,55.73Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.46,54.59a13.13,13.13,0,0,0,2-1.64c.19-.17.37-.34.61-.09s0,.39-.15.53c-.39.37-.78.75-1.19,1.11a18.19,18.19,0,0,1-1.56,1.22,2.76,2.76,0,0,0,.27-1.13Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.28,44.74a1.54,1.54,0,0,1-1.09-.37c-.26-.2-.46-.4-.86-.28-.23.07-.34-.27-.37-.48s.18-.17.32-.16l1,.07c.41,0,.85-.06,1,.5,0,.1.19.18.31.25s.31.1.27.3-.26.13-.41.17Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.89,43.4c.18,0,.43-.07.39.19s-.1.51-.4.45a.77.77,0,0,0-.76.23,1.7,1.7,0,0,1-1.6.4c-.07,0-.15,0-.16-.12a.2.2,0,0,1,.14-.25.94.94,0,0,0,.61-.62c0-.16.18-.18.32-.18A7.91,7.91,0,0,0,41.89,43.4Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.71,48.6l-1.24-.09c-.15,0-.33-.09-.34-.25s.18-.23.33-.23a4.27,4.27,0,0,0,2-.62c.45-.23.52-.16.48.33C22.89,48.39,22.65,48.58,21.71,48.6Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.24,42.82c-.19,0-.39.07-.49-.11s.11-.31.16-.47c.13-.37.38-.41.73-.42a15.12,15.12,0,0,0,1.57-.18c.13,0,.3-.16.35,0s-.05.49-.21.5c-.62,0-1.07.49-1.64.6Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,42.84a1.93,1.93,0,0,1-1.23-.36,1.29,1.29,0,0,0-.69-.23c-.31,0-.33-.17-.39-.33s0-.32.23-.26a9.62,9.62,0,0,0,2,.2c.19,0,.65.67.57.85S20.16,42.78,20,42.84Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.39,47.27a1.79,1.79,0,0,1,.74.27,2.42,2.42,0,0,0,1.45.41A.75.75,0,0,1,38,48c.22.1.22.29,0,.34s-.6.35-.93.08a.52.52,0,0,0-.25.06,1.66,1.66,0,0,1-1.1-.1.29.29,0,0,1-.22-.26C35.45,47.87,35.42,47.57,35.39,47.27Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.77,50.75a10.68,10.68,0,0,1-.37,1.48c-.11.31-.2.28-.38.08s-.6-.6-.88-.92S36,51,36.3,51a1.25,1.25,0,0,0,1-.41.42.42,0,0,1,.46-.12A.28.28,0,0,1,37.77,50.75Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.68,43.15a3.94,3.94,0,0,0,.77-.06c.13,0,.33-.18.36.08s-.08.56-.23.54c-.73-.09-1.3.52-2,.41-.27,0-.36-.07-.18-.34C37.75,43.19,37.74,43.18,38.68,43.15Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.3,51.17,21,52.59a5,5,0,0,1-.55-1.93c0-.26.32-.2.44-.07A2,2,0,0,0,22.3,51.17Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.46,46.3c-.09-.06-.14,0-.19.06a.58.58,0,0,1-.64.2.85.85,0,0,0-.66.1,1.6,1.6,0,0,1-1.19.17.35.35,0,0,1-.2-.16c0-.11.11-.12.17-.18.7-.66,1.58-.5,2.42-.54.32,0,.18.25.28.36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.43,44.13a.93.93,0,0,1-.59-.1,1.85,1.85,0,0,0-1-.26.38.38,0,0,1-.36-.26c-.13-.3-.1-.46.29-.4a4.18,4.18,0,0,0,1,.08c.51,0,.9.05,1.08.58,0,.09.16.16.12.28s-.21.07-.32.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.23,42.13c0,.17.15.42-.05.53s-.41-.06-.58-.17a5.55,5.55,0,0,1-1.08-.91.39.39,0,0,1-.06-.49c.11-.16.27,0,.4.07a2.08,2.08,0,0,0,.73.23C22.06,41.41,22.39,41.54,22.23,42.13Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.22,47.21a4.62,4.62,0,0,1-1.46.37c0,.18.18.13.22.3a7.48,7.48,0,0,1-2,.21,4.77,4.77,0,0,0,.49-.77c0-.1.12-.11.22-.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.27,48.11a6.13,6.13,0,0,1-2-.18c0-.22.24-.13.24-.32a5.19,5.19,0,0,1-1.5-.34,5.92,5.92,0,0,1,1.19,0,3.42,3.42,0,0,0,.64,0C18.61,47.06,19,47.48,19.27,48.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.26,40.68c-.06.69-.07.7-.65.45a1.48,1.48,0,0,1-.77-.6c-.13-.22-.37-.23-.53-.38s-.21-.28-.11-.42.21,0,.3.08a3.2,3.2,0,0,0,1.28.4C22.14,40.23,22.47,40.24,22.26,40.68Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.08,41.94c-.12-.38.09-.57.6-.59a2.61,2.61,0,0,0,.77-.27c.11,0,.22-.14.32,0a.29.29,0,0,1,0,.39,3.85,3.85,0,0,1-1.52,1.19c-.15,0-.19,0-.18-.15Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.09,40.66c-.08-.31,0-.47.41-.49a2.81,2.81,0,0,0,1.28-.42c.08,0,.18-.17.27,0s.09.27,0,.33c-.51.26-.8.79-1.33,1S36.11,41.29,36.09,40.66Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.66,46.11c-.27,0-.61-.2-.78-.11-.33.17-.51-.17-.77-.1a.17.17,0,0,1-.17-.16c0-.09.09-.15.18-.14.8.06,1.58-.33,2.38-.09.11,0,.26,0,.29.16s-.12.22-.24.27A2.47,2.47,0,0,1,21.66,46.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.15,47c0,.23.15.25.28.32s.16,0,.16.15-.09.14-.18.18a1.43,1.43,0,0,1-.71.06,3.38,3.38,0,0,0-1.1,0,.59.59,0,0,1-.45-.25c-.12-.13-.14-.29.12-.27A3,3,0,0,0,20.34,47,1.84,1.84,0,0,1,21.15,47Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.51,47.65c-.51-.08-1,.11-1.52,0-.14,0-.3,0-.33-.19s.16-.13.23-.21A1.11,1.11,0,0,1,38.18,47a4.22,4.22,0,0,0,.62.1c.13,0,.32-.06.36.1s-.15.27-.28.37A.34.34,0,0,1,38.51,47.65Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.53,46.06a2,2,0,0,1-.84-.16.16.16,0,0,1-.15-.2c0-.12.05-.19.15-.2a3.6,3.6,0,0,1,.8-.12c.54.08,1.08.13,1.62.19.08,0,.21,0,.21.1s-.09.16-.2.2A12.31,12.31,0,0,1,36.53,46.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.42,43.81c.08.31-.1.3-.32.21a1.2,1.2,0,0,1-.61-.37,1.22,1.22,0,0,0-.64-.52c-.18-.05-.19-.2-.13-.33s.18,0,.27,0a6.14,6.14,0,0,0,.73.22C22.38,43.14,22.4,43.14,22.42,43.81Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.15,47c-.21-.24-.21-.39.15-.45a5.36,5.36,0,0,0,1.24-.43c.13-.06.33-.25.41,0s.29.52-.12.69A1.11,1.11,0,0,1,22,47a1,1,0,0,0-.89.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.2,44.48a1.4,1.4,0,0,0,.5,0c.49-.15.52.28.69.52s0,.2-.14.21a.86.86,0,0,1-.32,0,9.31,9.31,0,0,0-1.58-.37.21.21,0,0,1-.17-.24c0-.12.12-.1.21-.1h.81Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.54,49a5.74,5.74,0,0,1-1.85,0l.32-.28c-.29-.14-.6,0-.83-.21.48-.07,1-.16,1.46-.19S20.21,48.73,20.54,49Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.06,44.48c0,.47-.51.45-.6.42-.35-.12-.55.12-.82.2h-.26c-.2,0-.53.11-.51-.14s.1-.63.47-.59A12.32,12.32,0,0,0,39.06,44.48Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.07,48.55l-.8.12c-.05.22.24.16.25.35a9,9,0,0,1-1.47,0c-.09,0-.2,0-.23-.1s.07-.15.13-.22a.92.92,0,0,1,1-.34,6.77,6.77,0,0,0,1.1.15Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.92,44c0-.25.06-.5.08-.76s.09-.2.23-.21a3.88,3.88,0,0,0,1.25-.35c.09.13.09.33,0,.35-.59.2-.82.91-1.48,1C36,44,36,44,35.92,44Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.49,46a6.54,6.54,0,0,0,1.53.56c.11,0,.27,0,.21.21s-.18.21-.3.14a.85.85,0,0,0-.73,0,1.09,1.09,0,0,1-.36,0c-.51,0-.58-.14-.43-.62A1.67,1.67,0,0,0,35.49,46Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.42,49.4a1.87,1.87,0,0,1-.94-.06c-.11-.06-.24-.09-.23-.23s.15-.14.25-.15a5.26,5.26,0,0,0,.88-.17c.16,0,.35-.25.48,0a.77.77,0,0,1,0,.52C22.82,49.48,22.58,49.39,22.42,49.4Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.69,45.29A.83.83,0,0,1,22,45a1.66,1.66,0,0,0-.67-.56.18.18,0,0,1-.14-.2s0,0,0-.05.16-.06.24,0c.28.06.56.13.84.17a.19.19,0,0,1,.21.19C22.52,44.67,22.64,45,22.69,45.29Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.53,49.62a1,1,0,0,1-.84.09c-.09,0-.33-.17-.25.15,0,.09-.1.1-.17.1a2.5,2.5,0,0,1-1.42-.27c.54,0,1,0,1.29-.36.09-.11.28,0,.43.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.75,49.73a2.42,2.42,0,0,1-1.07,0l1.32-.4a.17.17,0,0,1,.15.06c.26.35.63.38,1.1.38A2.35,2.35,0,0,1,21,50c-.14,0-.24-.06-.18-.23,0,0,.06-.06.05-.07A.12.12,0,0,0,20.75,49.73Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.1,49.31c-.22,0-.39.17-.51,0a.47.47,0,0,1-.07-.55c.12-.17.27,0,.4,0l.84.17c.1,0,.24,0,.23.15a.2.2,0,0,1-.19.21h0C36.54,49.27,36.3,49.63,36.1,49.31Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,44.22s0,.1-.06.11c-.45.1-.6.57-1,.78-.08,0-.16.13-.25.08s-.06-.2,0-.28,0-.52.2-.62a4.84,4.84,0,0,1,1-.23C37,44.05,37,44.13,37,44.22Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.93,52.46c.11-.28.21-.57.32-.85,0-.11,0-.33.21-.27a.32.32,0,0,1,.22.4.43.43,0,0,0,0,.35h-.05c-.15.21-.48.14-.59.39Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.39,28.44c.41,0,.74-.33,1.17-.24.12,0,.25,0,.23.19s-.1.17-.22.17H27.41Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.6,29.06a3.32,3.32,0,0,1,1.17.21.15.15,0,0,1,.13.16c0,.11-.12.12-.21.12A1.26,1.26,0,0,1,24.6,29.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.07,28.18c-.16,0-.14.13-.19.2s-.08.32-.21.3a.32.32,0,0,1-.2-.38.24.24,0,0,0,0-.12h0c.21.05.43-.34.64,0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.88,50.36a2.59,2.59,0,0,1,.38-.17c.12,0,.27-.27.37-.07a.39.39,0,0,1-.17.48c-.16.1-.31.12-.34-.14C22.12,50.42,22,50.41,21.88,50.36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.24,61.43v-.09c0-.22,0-.43.22-.54s.18.11.17.16c0,.21,0,.5-.32.56h0c0-.07,0-.12-.1-.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.42,61.7a2,2,0,0,1-.07-.35.32.32,0,0,1,.16-.34.2.2,0,0,1,.21,0,.37.37,0,0,1,0,.38c0,.18-.22.19-.35.27Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.22,27.86c0,.16-.22.16-.37.22s-.15,0-.15-.16,0-.34.24-.35S28.21,27.59,28.22,27.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.07,39.31c-.08-.05-.24.17-.23,0s-.05-.64.28-.83h.05a7.46,7.46,0,0,1-.1.81Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.28,27.8H23.93a2.49,2.49,0,0,1,1.35-.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.08,51.84c-.12-.08-.22-.18-.19-.33s.08-.28.25-.27a.23.23,0,0,1,.2.26h0A.5.5,0,0,1,29.08,51.84Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.32,28.83h2.14v.05H26.3Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.61,61.15c-.09-.07-.21,0-.29-.06a.4.4,0,0,1-.07-.38.16.16,0,0,1,.19-.12h0c.17.06.13.21.12.34s-.05.15,0,.21Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,50.67c-.16-.2-.23-.35-.16-.55C36.28,50.17,36.15,50.39,36,50.67Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.44,61.47c0-.16-.23-.28-.12-.47a.2.2,0,0,1,.15,0C36.64,61.14,36.58,61.31,36.44,61.47Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,50.4c-.07.1-.12.21-.24.18a.22.22,0,0,1-.16-.24c0-.12.14-.08.22-.07S29,50.31,29,50.4Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.39,27.88a.23.23,0,0,1,.27,0A.23.23,0,0,1,28.39,27.88Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.39,51.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.35,53.58h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.45,30.78s-.06-.08,0-.11h.07Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.61,32.79h.08v.06A.16.16,0,0,1,50.61,32.79Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.67 55.9 25.67 55.93 25.65 55.93 25.67 55.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.75,33.85h-.06v-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.86,41.48l.05.05h0v-.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.66,52.09l.06.12h0l-.08-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.12,38.45l.11-.08h0l-.07.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.77,49.61Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.67,51.32a2.37,2.37,0,0,1-.92-.91A1.74,1.74,0,0,1,10.67,51.32Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.31,51.87a1.32,1.32,0,0,1-.64-.55A.66.66,0,0,1,11.31,51.87Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.77,53.7a.51.51,0,0,1-.46-.28C13.55,53.37,13.68,53.5,13.77,53.7Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,53.88c-.17,0-.27,0-.28-.19A.25.25,0,0,1,14,53.88Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,48.68a.11.11,0,0,1-.1-.18C8,48.38,8.06,48.58,8,48.68Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.14,6.7Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.77,4.69Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.22,48.86c-.07,0-.1,0-.1-.09S8.22,48.8,8.22,48.86Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.12,48.77A.08.08,0,0,1,8,48.68Q8.14,48.67,8.12,48.77Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.76,17.72h0v0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.49,13.9Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.49,44.21Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.13,39.2Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.76,50.41c-.1,0-.13,0-.1-.09S9.76,50.35,9.76,50.41Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.67,50.32c-.1,0-.13,0-.1-.09S9.67,50.26,9.67,50.32Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.58,50.23c-.1,0-.13,0-.1-.09a.09.09,0,0,1,.1.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.49,50.14c-.1,0-.14,0-.1-.09a.09.09,0,0,1,.1.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.4,50.05c-.1,0-.14,0-.1-.1A.11.11,0,0,1,9.4,50.05Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.31,50c-.11,0-.14,0-.1-.1A.11.11,0,0,1,9.31,50Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.11,39.12v.11h0l.06-.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.11,32.28Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.2,10.06v.06h-.07Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.74,13.9Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.76,41.5H51.7v-.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.62,64.89c.09-.16.24-.16.39-.17a32.64,32.64,0,0,0,3.69-.47,1.23,1.23,0,0,1,.66,0h0c-.06.09-.16.08-.24.1a30.75,30.75,0,0,1-4.49.54Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.75,61.55a18.45,18.45,0,0,1-4.33,0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.23,61.42c.09,0,.1,0,.1.1S20.23,61.49,20.23,61.42Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.29,2.49a.11.11,0,0,1,.07.14.08.08,0,0,1,0,0l-.13-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,1.69Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.83,39.47h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.56,8.43h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.69,8.36c.08.06.09.12,0,.16Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.29,44.86V44.8h.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.76,42.3Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.62,64.88a30.75,30.75,0,0,0,4.49-.54.24.24,0,0,0,.24-.1,21.17,21.17,0,0,0,3.91-1,37.72,37.72,0,0,0,7.26-3.52,7.44,7.44,0,0,0,.85-.52c.21-.15.36-.13.49.07s0,.32-.18.43A29.77,29.77,0,0,1,44.84,62a36.15,36.15,0,0,1-9.84,3,34.57,34.57,0,0,1-11.57,0,34.33,34.33,0,0,1-12.5-4.5c-.44-.26-.87-.55-1.3-.83-.17-.11-.3-.24-.15-.45a.3.3,0,0,1,.42-.12l0,0,.27.17A30.77,30.77,0,0,0,22.8,64.43,34.88,34.88,0,0,0,29,65,12.75,12.75,0,0,0,31.62,64.88Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.18,14.58c.23-.25.47-.49.71-.74a.39.39,0,0,1,.32-.13,19.1,19.1,0,0,1,2,.07l-3,.88Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,21.35c0,.13,0,.23-.17.19a10.86,10.86,0,0,1-1.22-.4,2.26,2.26,0,0,1,1.21,0h0c0,.07,0,.1.1.1h0c0,.07,0,.1.1.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,21.12a5.28,5.28,0,0,1-1.45.44C32.9,20.87,33.48,21.12,34,21.12Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.17,16.16c0,.15,0,.23-.19.18a11.2,11.2,0,0,1-1.27-.44h1.18c0,.09,0,.12.1.1h0c0,.09,0,.12.1.1h0c0,.09,0,.12.1.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.64,16.38c.34-.74.94-.42,1.46-.42Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.52,11.25a.15.15,0,0,0-.17-.1h0c0-.11,0-.13-.12-.17-.22-.19-.1-.43-.1-.66a6.65,6.65,0,0,1,.91,1.2h-.14A.59.59,0,0,0,23.52,11.25Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.23,10c.38-.71,1-.45,1.47-.43Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.42,16.26c0,.18-.16.1-.24.07A7.25,7.25,0,0,1,20,15.9h1.2c-.09.12,0,.15.09.19h0l.1.09h0l.1.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.86,16.4c.38-.73,1-.47,1.49-.45Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.79,7.24a.11.11,0,0,1-.11.11l-.06,0a8.65,8.65,0,0,1-1.3-.44h1.11c0,.06,0,.09.1.1h0a.09.09,0,0,0,.08.1h0a.09.09,0,0,0,.08.1h0a.09.09,0,0,0,.08.1h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.16,8.43c0-.1,0-.09-.09-.09V7.76c.28.36.74.6.78,1.12H29.8c0-.07,0-.09-.09-.09a.13.13,0,0,0-.16-.09h0c0-.15-.08-.17-.18-.19S29.26,8.38,29.16,8.43Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.64,7l-1.42.42C29.56,6.64,30.14,6.93,30.64,7Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.07,21.54c.32-.67.93-.41,1.45-.43a4.17,4.17,0,0,1-1.46.43Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.79,22.91c-.11-.29.21-.5.17-.79.12-.12.31-.22.43-.08s-.09.26-.17.36A1.71,1.71,0,0,1,24.79,22.91Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.77,23s-.06-.06-.06-.09.05-.06.09,0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.06,21.54v.06H26l.07-.05Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.75,9.51h1.12a5.53,5.53,0,0,1-1.53.52C35.41,9.76,35.63,9.67,35.75,9.51Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,11.47c0-.08,0-.2.1-.22S34.05,11.42,34,11.47Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.68,10.4s.07-.06.11,0l-.06.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.55,14.23s.09.06,0,.09-.06,0-.07-.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.43,14.17a.08.08,0,0,1-.09-.07v0h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.3,13.93l.07.12h0l-.1-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.46,14.14l.09.09h0a.08.08,0,0,1-.09-.07Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.24,14s-.07-.07-.06-.08h.12Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.31,47.58Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.79,9.87a.17.17,0,0,1-.14-.15h.07c.07,0,.12.09.08.18Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.53,7c-.07,0-.1,0-.1-.1S28.54,6.9,28.53,7Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.71,7.16a.09.09,0,0,1-.1-.08v0C28.7,7,28.73,7.07,28.71,7.16Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.8,7.25a.09.09,0,0,1-.1-.08v0C28.79,7.12,28.8,7.18,28.8,7.25Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.62,7.07a.09.09,0,0,1-.1-.08V7C28.61,7,28.64,7,28.62,7.07Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.24,16.08a.11.11,0,0,1-.09-.19C21.21,15.94,21.3,16,21.24,16.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.42,16.27l-.1-.1C21.41,16.15,21.44,16.18,21.42,16.27Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.33,16.17l-.1-.09C21.33,16.05,21.35,16.09,21.33,16.17Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,21.36c-.07,0-.1,0-.1-.1S32,21.3,32,21.36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.9,21.27c-.07,0-.1,0-.1-.1S31.92,21.18,31.9,21.27Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.18,16.17c-.09,0-.13,0-.1-.1A.11.11,0,0,1,36.18,16.17Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,16c-.08,0-.12,0-.1-.1A.09.09,0,0,1,36,16Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.09,16.08c-.09,0-.13,0-.1-.1A.11.11,0,0,1,36.09,16.08Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.34,40.38a4,4,0,0,0,0,.92c.07.32-.27.14-.43.17A1.81,1.81,0,0,1,35.34,40.38Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.43,48.66c0,.14-.11.11-.18.15S33.28,48.6,33.43,48.66Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.43,40.2c.09.12,0,.18-.09.18S35.33,40.23,35.43,40.2Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.52,48.57q0,.12-.09.09T33.52,48.57Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.61,48.48q0,.12-.09.09C33.48,48.48,33.51,48.44,33.61,48.48Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.7,48.39q0,.12-.09.09C33.57,48.38,33.61,48.35,33.7,48.39Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.52,40.1c0,.07,0,.15-.09.1S35.42,40.06,35.52,40.1Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.07,29.19c-.16.2-.72-.11-.55.52-.23-.56-.15-.62.54-.52Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,34.59s-.06-.06,0-.09h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.6,34.56a.89.89,0,0,1-.73-.64A2.36,2.36,0,0,1,17.6,34.56Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.64,32.65c0,.1,0,.13-.1.09S42.57,32.64,42.64,32.65Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.55,32.74c0,.1,0,.13-.1.09S42.48,32.73,42.55,32.74Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.36,32.92c0,.1,0,.13-.09.1S42.3,32.92,42.36,32.92Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.73,33.56c0,.1,0,.13-.1.09S41.66,33.55,41.73,33.56Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.64,33.65c0,.1,0,.13-.1.09S41.57,33.64,41.64,33.65Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.46,32.83c0,.1,0,.13-.1.09S42.39,32.83,42.46,32.83Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.8,57Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.12,59.75c.05,0,.11-.1.18,0l-.09.12Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.88,57.41l.05.08h-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.06,57.05v.05h0V57Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.55,58.29v.1h-.11Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.42,59.72c-.05,0-.15,0-.14-.06s.13,0,.2,0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.49,57.74h-.11v-.09Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.46,25.09l-.05.05h.05Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.8,25.05s.06.07,0,.11l-.06-.06Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.05,30.82v.05H8Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.58,27.74Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.64,27.64v.06h0Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.75,49.73s.07-.06.1,0,0,.05-.05.07Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.06,62.79l.7.14c.13,0,.15.14.13.25s-.11.12-.21.1L23,63.15a.21.21,0,0,1-.19-.23s0,0,0,0S23,62.8,23.06,62.79Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.9,59.33c.1.06.28,0,.3.2a.18.18,0,0,1-.16.2h0a.31.31,0,0,1-.29-.24C12.71,59.39,12.78,59.34,12.9,59.33Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 28.26,
    cy: 30.77,
    rx: 1.08,
    ry: 0.04
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistry);
export default __webpack_public_path__ + "static/media/ministry.979197b96fd11f469afc4a7ab37f2028.svg";
export { ForwardRef as ReactComponent };